/**
 * This file is auto-generated (gulp api-gen-help)
 */
/* eslint-disable */
import {HelpNode} from './api-help'

export function getAllHelpTopics(): HelpNode[] {
  const notifierFields = [
    new HelpNode(
      'error',
      'error(message)',
      `
      Notifier.error('');`,
      `Notifier.error('Task was added successfully');`,
      `Shows error notification`,
      `Показывает нотификацию ошибки.`
    ),
    new HelpNode(
      'warn',
      'warn(message)',
      `
      Notifier.warn('');`,
      `Notifier.warn('This task is readonly!');`,
      `Shows warning notification`,
      `Показывает нотификацию предупреждения.`
    ),
    new HelpNode(
      'success',
      'success(message)',
      `
      Notifier.success('');`,
      `Notifier.success('Task was added successfully');`,
      `Shows success notification`,
      `Показывает нотификацию успешно выполненного действия.`
    ),
    new HelpNode(
      'show',
      'show(title, message, onClick)',
      `
      Notifier.show('', '');`,
      `Notifier.show('New message', 'Hi, how’s it going?');`,
      `Shows browser notification`,
      `Показывает браузерную нотификацию.`
    ),
    new HelpNode(
      'playSound',
      'playSound(soundNumber)',
      `
      Notifier.playSound();`,
      `
      // default sound as in chats
      Notifier.playSound();

      // another sound (7 sounds available)
      Notifier.playSound(2);`,
      `Plays sound`,
      `Проигрывает звук. Доступны 7 вариантов звуков.`
    )
  ]
  const notifierHelp = new HelpNode(
    'Notifier',
    'Notifier',
    `Notifier`,
    '',
    `
    Object “Notifier” provides various ways to notify user
    (see available methods).`,
    `
    Объект "Notifier" предлагает различные пути для нотификации
    пользователя (см. доступные методы).`,
    notifierFields
  )

  const currentFields = [
    new HelpNode(
      'user',
      'user',
      `
      Current.user;`,
      `
      if (Current.user.name === 'John') {
        Notifier.success('Hi John!');
      }`,
      `Current user (see “user variable”).`,
      `Текущий пользователь (см. “user variable”).`
    ),
    new HelpNode(
      'project',
      'project',
      `
      Current.project;`,
      ``,
      `
      Opened project (see “item variable”). Readonly.
      To open another project use .open()
      method of item variable.`,
      `
      Открытый проект (см. “item variable”). Только для чтения.
      Чтобы открыть другой проект, используйте метод .open()
      (см. “item variable”).`
    ),
    new HelpNode(
      'board',
      'board',
      `
      Current.board;`,
      ``,
      `
      Opened board (see “item variable”). Readonly.
      To open another board use .open()
      method of item variable.`,
      `
      Открытая доска (см. “item variable”). Только для чтения.
      Чтобы открыть другую
      доску, используйте метод .open() (“item variable”).`
    ),
    new HelpNode(
      'chat',
      'chat',
      `
      Current.chat;`,
      ``,
      `
      Opened chat’s task (see “item variable”). Readonly.
      To open another chat use
      Chat.openChat(...) method.`,
      `
      Открытый чат задачи (см. “item variable”). Только для чтения.
      Чтобы открыть
      другой чат, используйте метод Chat.openChat(...).`
    ),
    new HelpNode(
      'company',
      'company',
      `
      Current.company;`,
      `
      var company = Current.company;
      Notifier.success('Company is ' + company.name);`,
      `
      Returns current company. Script scope is restricted to one
      company so it always remains the same. If user switches the
      company script is unloaded.`,
      `
      Возвращает компанию, в которой запускается скрипт.
      Работа скрипта ограничена одной компанией, поэтому
      компания остаётся всегда одинаковой. Если пользователь переходит
      в другую компанию, скрипт отгружается и запускаются скрипты другой
      компании.`
    ),
    new HelpNode(
      'onProjectChange',
      'onProjectChange(oldProject, newProject)',
      `
      Current.onProjectChange = function (oldProject, newProject) {
      };`,
      `
      Current.onProjectChange = function (x, y) {
        Notifier.success('Navigated to ' + y.name);
      };`,
      `
      This function is called when user navigates to another project.
      If user leaves a project (e.g.: navigates to the project page) then this
      function is called with an undefined second argument.`,
      `
      Эта функция вызывается, когда пользователь переходит в другой проект.
      Если пользователь покидает проект (т.е. переходит на страницу проектов),
      то эта функция вызывается с неопределенным (undefined) вторым аргументом.`
    ),
    new HelpNode(
      'onBeforeScriptUnload',
      'onBeforeScriptUnload(oldBoard, newBoard)',
      `
      Current.onBeforeScriptUnload = () => {
        // disposing resources
      }`,
      `
      const instance = new Logic();
      Current.onBeforeScriptUnload = function () {
        instance.Dispose();
      };`,
      `This function is called when the extension's script is about to be unloaded.`,
      `Эта функция вызывается, когда скрипт расширения готовится к выгрузке.`
    ),
    new HelpNode(
      'onBoardChange',
      'onBoardChange(oldBoard, newBoard)',
      `
      Current.onBoardChange = function (oldBoard, newBoard) {
      };`,
      `
      Current.onBoardChange = function (x, y) {
        Notifier.success('Board ' + y.name + ' opened!');
      };`,
      `This function is called when user navigates to a new board.`,
      `Эта функция вызывается, когда пользователь переходит в новую доску.`
    ),
    new HelpNode(
      'onChatChange',
      'onChatChange(oldChat, newChat)',
      `
      Current.onChatChange = function (oldChatTask, newChatTask) {
      };`,
      `
      Current.onChatChange = function (x, y) {
        Notifier.success('Opened chat for ' + y.name + ' task!');
      };`,
      `This function is called when the opened chat’s task changes.`,
      `Эта функция вызывается, когда открывается чат по другой задаче.`
    )
  ]
  const currentHelp = new HelpNode(
    'Current',
    'Current',
    `Current`,
    `
    // getting current user
    if (Current.user.name === 'John Smith') {
      Notifier.success('Hi John!');
    }`,
    `Object Current contains information about the current application state.`,
    `Объект "Current" содержит информацию о текущем статусе приложения.`,
    currentFields
  )

  const itemsFields = [
    new HelpNode(
      'get',
      'get(id)',
      `
      Items.get('');`,
      `
      // getting a task and assigning it to variable “t” for later use
      var t = Items.get('bb12a559-81ba-40ad-adda-81f2d017e71b');

      // appending “!” to the task’s name
      t.name = t.name + '!';`,
      `
      Gets Yougile object by it’s id.
      Yougile objects are: company, projects, boards, column and tasks.
      You can find object’s id in “Object navigator” tab`,
      `
      Получает объект YouGile по его id.
      Объекты YouGile: компания, проекты, доски, колонки, задачи.
      Вы можете найти id объектов во вкладке "Навигатор по объектам".`
    ),
    new HelpNode(
      'onAdd',
      'onAdd(newObject)',
      `
      Items.onAdd = function (object) {
      };`,
      `
      Items.onAdd = function (obj) {
        if (obj.type === 'Task') { // only when a task was added
          // changing a name of the new task
          obj.name = obj.name + ' ...';
        }
      };`,
      `
      This function is called after a new object was added
      (task, column, board, project).`,
      `
      Эта функция вызывается сразу после добавления нового объекта в систему
      (задачи, колонки, доски, проекта).`
    ),
    new HelpNode(
      'onBeforeAdd',
      'onBeforeAdd(location, name)',
      `
      Items.onBeforeAdd = function (location, name) {
        return true;
      };`,
      `
      Items.onBeforeAdd = function (a, s) {
        if (a.type === 'Column') { // only when a task is added to a column
          // prevent task addition with name “test”
          if (s === 'test') {
            return false;
          }
        }
        // we return true because we want to proceed addition
        // if it is needed to prevent addition, then return false
        return true;
      };`,
      `
      This function is called before the addition of new object
      (task, column, board, project). First argument is a location where
      new object is added (e.g. if a task is added then it is a column), second
      argument is a name of the new object.
      If this function return false, then new object is not added.`,
      `
      Эта функция вызывается, перед добавлением нового объекта в систему.
      Первый аргумент — куда добавляется новый объект (напр. если добавляется
      задача, то в первом аргументе колонка, куда добавляется), второй аргумент
      — имя нового объекта. Если функция возвращает false, добвление
      отменяется.`
    ),
    new HelpNode(
      'onRename',
      'onRename(item, newName)',
      `
      Items.onRename = function (object, newName) {
        return true;
      };`,
      `
      Items.onRename = function (obj, n) {
        if (obj.type === 'Task') { // only for task renaming
          obj.name = n + '!!!';
          // return false to stop the default action — renaming the
          // object to a name specified by user (n variable in our case)
          return false;
        }
        // make the default action in all other cases
        return true;
      };`,
      `
      This function is called when some object is renamed (task, column,
      board, project).`,
      `
      Эта функиця вызывается, когда какой-нибудь объект переименовывается
      (задача, колонка, доска или проект).`
    ),
    new HelpNode(
      'onDelete',
      'onDelete(item)',
      `
      Items.onDelete = function (object) {
        return true;
      };`,
      `
      Items.onDelete = function (object) {
        // preventing to delete object which name starts with 'Important'
        if (object.name.slice(0, 9) === 'Important') {
          Notify.warn('You’re not allowed to delete important things!');
          return false;
        }
        // otherwise proceed with deletion
        return true;
      };`,
      `
      This function is called when user deletes some object (task, column,
      board or project).`,
      `
      Эта функция вызывается, когда юзер удаляет какой-нибудь объект (задачу,
      колонку, доску или проект).`
    ),
    new HelpNode(
      'onChangeArchived',
      'onChangeArchived(item)',
      `
      Items.onMakeArchived = function (object) {
        return true;
      };`,
      ``,
      `
      This function is called when the user places an object into the archive. (task, column,
      board or project).`,
      `
      Эта функция вызывается, когда юзер помещает в архив какой-нибудь объект (задачу,
      колонку, доску или проект).`
    ),
    new HelpNode(
      'onClick',
      'onClick(item)',
      `
      Items.onClick = function (object) {
        return true;
      };`,
      `
      Items.onClick = function (object) {
        Notifier.success('You’ve clicked ' + object.name);
        return true;
      };`,
      `
      This function is called when a user clicks on task, column header,
      board tab or project.`,
      `
      Эта функция вызывается, когла пользователь щелкает на задачу, заголовок
      колонки, вкладку доски или на проект.`
    ),
    new HelpNode(
      'onList',
      'onList(item, items)',
      `
      Items.onList = function (object, children) {
        return children;
      };`,
      `
      Items.onList = function (obj, arr) {
        // obj - is a container which child objects are going to be listed
        // arr - is its actual children objects
        if (obj.type === 'Column') { // in case of task list in a column
          // here obj is a column and arr is all its tasks

          // we return only 5 elements from the array of tasks,
          // this result is going to be shown to the user
          // so user is going to see no more than 5 tasks in every column
          return arr.slice(0, 5);
        }
        // otherwise we return default
        return arr;
      };`,
      `
      This function is called when system is trying to show the list of
      object inside some object. For example when it draws a list of
      tasks inside of a column, or a list of columns inside of a
      board and so on.`,
      `
      Эта функция вызывается, когда система показывает список объектов внутри
      какого-то объекта. Например, когда отрисовывается список задач внутри
      колонки или список колонок внутри доски и так далее.`
    ),
    new HelpNode(
      'onMove',
      'onMove(item, from, to)',
      `
      Items.onMove = function (object, from, to) {
        return true;
      };`,
      `
      Items.onMove = function (obj, from, to) {
        // getting some board by id
        var brd = Items.get('... board id here');
        // suppose we want to disable moving tasks in this board

        // so we check if parent object of from is this board
        // if so then from object is some column inside this board
        // and that’s why obj is some task inside this column which user is
        // trying to move somewhere. So we return false to prevent it.
        if (from.up().id === brd.id) {
          Notifier.warn('Moving tasks inside ' +
            brd.name + ' board is disallowed');
          return false;
        }
        return true;
      };`,
      `
      This function is called when user moves some object from one location to
      another (for example moves task from one column to another).`,
      `
      Эта функция вызывается, когда пользователь перемещает объект из одного
      места в другое (например, перемещает задачу из одной колонки в другую).`
    ),
    new HelpNode(
      'onUpdate',
      'onUpdate(item)',
      `
      Items.onUpdate = function (obj) {
      };`,
      `
      var column = Items.get('...');
      // let’s store a number of tasks
      // in this column in some variable
      var tasksCount = column.list().length;

      // if we want to recalculate tasksCount
      // on changes then we can do it as follows
      Items.onUpdate = function (obj) {
        if (obj.id === column.id) {
          tasksCount = column.list().length;
        }
      };`,
      `
      This function is called when some item (project, board, column, task)
      was updated by the current user or by other connected user
      (remote update).
      If chat was updated than this function is also called and the
      corresponding task is passed to it.`,
      `
      Эта функция вызывается когда какой-то объект системы был обновлён
      (проект, доска, колонка, задача). Учитываются не только обновления
      текущим пользователем, но и другие обновления, приходящие с сервера.
      Если произошло обновление чата, то вызывается эта функция с
      соответсвующей задачей в качестве аргумента.`
    ),
    new HelpNode(
      'isHidden',
      'isHidden(item)',
      `
      Items.isHidden = function (object) {
        return false;
      };`,
      `
      Items.isHidden = function (x) {
        // we do not want to show some column to user Mike
        if (Current.user.email === 'mike@example.com') { // better to compare id
          if (x.id === '... here goes column id') {
            return true;
          }
        }
        return false;
      };`,
      `
      If this function returns true for some object in some case, then this
      object is not shown.
      Если эта функция возвращает true для какого-нибудь объекта в какой-нибудь
      ситуации, то этот объект не отображается.`,
      ``
    ),
    new HelpNode(
      'allowDelete',
      'allowDelete(item)',
      `
      Items.allowDelete = function (object) {
        return true;
      };`,
      `
      Items.allowDelete = function (object) {
        if (object.type === 'Column') {
          // hide all delete buttons from all columns
          return false;
        }
        return true;
      };`,
      `
      If this function returns false for some object in some case
      then delete button is not shown for this object
      (task, column, board, project).`,
      `
      Если эта функция возвращает false для какого-нибудь объекта в
      какой-нибудь ситуации, то кнопка удаления не показывается для
      этого объекта (задачи, колонки, доски или проекта).`
    ),
    new HelpNode(
      'allowAdd',
      'allowAdd(item)',
      `
      Items.allowAdd = function (to) {
        return true;
      };`,
      `
      Items.allowAdd = function (a) {
        // remove “Add a new task” button from all columns
        if (a.type === 'Column') {
          return false;
        }
        return true;
      };`,
      `
      If this function returns false for some object then add button is not
      shown inside this object.`,
      `
      Если эта функция возвращает false для какого-нибудь объекта, тогда
      кнопка добавления не отображается внутри этого объекта.`
    ),
    new HelpNode(
      'allowRename',
      'allowRename(item)',
      `
      Items.allowRename = function (object) {
        return true;
      };`,
      `
      Items.allowRename = function (object) {
        // disallow renaming to a specific user
        if (Current.user.id === '... user id here') {
          return false;
        }
        return true;
      };`,
      `
      If this function returns false for some object then it can’t be renamed
      from interface.`,
      `
      Если эта функция возвращает false для некоторого объекта, тогда он не
      может быть переименован через интерфейс.`
    ),
    new HelpNode(
      'allowDrag',
      'allowDrag(item)',
      `
      Items.allowDrag = function (object) {
        return true;
      };`,
      `
      Items.allowDrag = function (object) {
        // disallow dragging to a specific user
        if (Current.user.id === '... user id here') {
          return false;
        }
        return true;
      };`,
      `
      If this function returns false for some object then it can’t
      be dragged (task, board, column or project).`,
      `
      Если эта функция возвращает false для объекта, то его нельзя
      перетаскивать.`
    )
  ]
  const itemsHelp = new HelpNode(
    'Items',
    'Items',
    `Items`,
    '',
    `
    Allows to manipulate all YouGile objects (tasks, columns, boards, projects)
    and describes behaviour common to all such objects.

    Projects, boards, columns and tasks are structured as some hierarchical
    system similar to files and folders on your computer
    (see “Object navigator” tab). “Items” allows to access and
    manipulate them in this manner. So when you are addressing
    some task or board from Items it gives you an “item variable”.`,
    `
    Позволяет манипулировать всеми объектами внутри YouGile (задачи, колонки,
    доски, проекты) и описывает поведение по умолчанию для этих объектов.

    Проекты, борды, колонки и задачи структурированы в некую
    иерархичную систему,
    похожую на файловую систему компьютера
    (смотри вкладку "Навигатор по объектам").

    "Items" позволяет получить доступ и управлять ими на этот манер.
    И когда вы обращаетесь к какой-либо задаче или доске через Items,
    вы получаете переменную типа item (см. “item variable”).`,
    itemsFields
  )

  const itemFields = [
    new HelpNode(
      'type',
      'type',
      `
      Items.get('... object id').type;`,
      ``,
      `
      Returns the string with a type of the object,
      available types are: 'Task', 'Subtask',
      'Column', 'Board', 'Project'. Readonly.`,
      `
      Возвращает строку с типом объекта. Доступные типы: 'Task', 'Subtask',
      'Column', 'Board', 'Project'. Только для чтения.`
    ),
    new HelpNode(
      'name',
      'name',
      `
      Items.get('... object id').name;`,
      `
      var task = Items.get('...');
      task.name = task.name + '!';`,
      `
      Returns a name of the object. Name can be changed by assigning to
      this property.`,
      `Возвращает имя объекта.`
    ),
    new HelpNode(
      'deleted',
      'deleted',
      `
      Items.get('... object id').deleted;`,
      ``,
      `
      Returns true if the object is deleted. You can assign a value to this
      property.`,
      `
      Возвращает true если объект удалён. Вы можете назначить
      значение этому свойству.`
    ),
    new HelpNode(
      'timestamp',
      'timestamp',
      `
      Items.get('... object id').timestamp;`,
      ``,
      `Returns unix timestamp of the creation time of the object. Readonly.`,
      `Возвращает unix timestamp даты создания объекта. Только чтение.`
    ),
    new HelpNode(
      'path',
      'path',
      `
      Items.get('... object id').timestamp;`,
      `
      var task = Items.get('... some task id');
      task.path;
      // returns:
      // 'My company » Example project » First board » Main column'`,
      `Returns a human readable path for the object.`,
      `Возвращает форматированный путь к объекту.`
    ),
    new HelpNode(
      'ui',
      'ui',
      `
      Items.get('... object id').ui;`,
      `
      var task = Items.get('... some task id');
      task.ui.style = {
        background: 'red'
      };`,
      `
      UI element corresponding to the object
      (see UIElement for details).`,
      `
      UI элемент, соответсвующий объекту
      (cм. UIElement).`
    ),
    new HelpNode(
      'open',
      'open()',
      `
      Items.get('... object id').open();`,
      `
      // open “My project” project
      Company.find('My project').open();`,
      `
      Navigate user to the object (project or board). If it is called from task
      or column then the containing board is opened.`,
      `
      Перемещение пользователя к объекту (проекту или доске). Если
      вызывается из задачи или колонки, открывается содержащая их
      доска.`
    ),
    new HelpNode(
      'move',
      'move(newParent)',
      `
      Items.get('... object id').move(Items.get('??? new parent id'));`,
      ``,
      `
      Moves the object to a new parent (for example you can move a task
      to another column).`,
      `
      Перемещает объект к новому родителю (например, вы можете
      переместить задачу в другую колонку).`
    ),
    new HelpNode(
      'find',
      'find(name)',
      `
      Items.get('... object id').find('... name');`,
      ``,
      `Gets a child object of the object with the specified name.`,
      `Получает дочерний объект объекта с определенным именем.`
    ),
    new HelpNode(
      'up',
      'up()',
      `
      Items.get('... object id').up();`,
      `
      // getting a task
      var t = Items.get('... task id here');
      // column
      var col = t.up();
      // board
      var b = col.up();
      Notifier.success('The task ' + t.name + ' is inside board ' + b.name);`,
      `Returns parent object of the specified object.`,
      `Возвращает родительский объект указанного объекта.`
    ),
    new HelpNode(
      'list',
      'list()',
      `
      Items.get('... object id').list();`,
      `
      // getting the board
      var b = Items.get('... board’s id');
      b.list(); // array of columns inside the board`,
      `Returns an array of children objects for the object.`,
      `Возвращает массив дочерних объектов указанного объекта.`
    ),
    new HelpNode(
      'add',
      'add(name)',
      `
      Items.get('... object id').add('... name');`,
      `
      // getting a column
      var c = Items.get('... column id here');
      c.add('Some new task!');

      // we can also save a new object to a variable to
      // work with it later
      var t2 = c.add('Another task');
      t2.name = 'Name changed';`,
      `Adds a new child object with the specified name.`,
      `Добавляет новый дочерний объект указанного объекта.`
    ),
    new HelpNode(
      'getData',
      'getData(key)',
      `
      Items.get('... object id').getData('key');
      `,
      `
      var t = Items.get('... task id');
      var specificData = t.getData('clientId');
      console.log(specificData); // '9023929875'
      `,
      `
      Gets specific custom data attached to the object by the given key.
      `,
      `
      Получает пользовательские данные, прикреплённые к объекту, по указанному ключу.
      `
    ),
    new HelpNode(
      'setData',
      'setData(key, json)',
      `
      Items.get('... object id').setData('key', {...});`,
      `
      var t = Items.get('... task id');
      var d = {
        clientId: '9023929875'
        contact: {
          phone: '+1234567',
          email: 'some@example.com'
        }
      };
      t.setData('client-info', d);
      // this data is now saved on server and can be accessed
      // from scripts for all users.

      // modification existent data example
      var data = t.getData('order');
      data.orderNum = 2341;
      t.setData('order', data);`,
      `
      Custom data can be attached to any YouGile object
      (JSON). This data is automatically
      synchronized with server and all users and if available
      with getData function.`,
      `
      К любому объекту YouGile можно добавить пользовательские
      данные (JSON). Они будут автоматически синхронизированы
      с сервером и всеми юзерами и доступны через
      функцию getData.`
    ),
    new HelpNode(
      'triggerUpdate',
      'triggerUpdate(allUsers = false)',
      `
      Items.get('...').triggerUpdate(false);`,
      ``,
      `
      Tells the system that the item should be considered as updated and
      should be redrawn.`,
      `
      Принудительно вызвать событие обновления объекта
      (система перерисует всё что связано с объектом и выполнит
      функцию Items.onUpdate, если значение параметра false - вызовется для текущего клиента,
      если значение true - то для всех клиентов).`
    ),
    new HelpNode(
      'isArchived',
      'isArchived()',
      `
      Items.get('... task id').isArchived();`,
      `
      const task = Items.get('...');
      const completed = task.isArchived();`,
      `Returns true is the object is archived.`,
      `Возвращает true если объект помещён в архив.`
    ),
    new HelpNode(
      'isCompleted',
      'isCompleted()',
      `
      Items.get('... task id').isCompleted();`,
      `
      const task = Items.get('...');
      const completed = task.isArchived();`,
      `Returns true is the object is a completed task.`,
      `Возвращает true если объект — это выполненная задача.`
    ),
    new HelpNode(
      'setCompleted',
      'setCompleted(value)',
      `
      Items.get('... task id').setCompleted(true);`,
      `
      const task = Items.get('...');
      task.setCompleted();`,
      `Completes or uncompletes the task.`,
      `Выполняет задачу (либо снимает выполненность, если значение параметра false).`
    ),
    new HelpNode(
      'getAllParentTasks',
      'getAllParentTasks(force)',
      `
      Items.get('... task id').getAllParentTasks();`,
      `
      const task = Items.get('...');
      task.getAllParentTasks();`,
      `Returns an array of all parent tasks.`,
      `Возвращает массив всех родительских задач.`
    ),
    new HelpNode(
      'getTaskLocations',
      'getTaskLocations()',
      `
      Items.get('... task id').getTaskLocations();`,
      `
      const task = Items.get('...');
      task.getTaskLocations();`,
      `Returns task locations - board, column, project.`,
      `Возвращает расположение задачи - доска, колонка, проект.`
    ),
    new HelpNode(
      'getAssignedUsers',
      'getAssignedUsers()',
      `
      Items.get('... task id').getAssignedUsers();`,
      `
      const task = Items.get('...');
      task.getAssignedUsers();`,
      `Returns assigned users.`,
      `Возвращает пользователей, назначенных задаче.`
    ),
    new HelpNode(
      'setAssignedUsers',
      'setAssignedUsers(users)',
      `
      Items.get('... task id').setAssignedUsers();`,
      `
      const task = Items.get('...');
      task.setAssignedUsers();`,
      `Sets assigned users.`,
      `Устанавливает пользователей, назначенных задаче.`
    ),
    new HelpNode(
      'setTaskCompleted',
      'setTaskCompleted(value)',
      `
      Items.get(''... task id).setTaskCompleted(true);`,
      `
      const task = Items.get('...');
      const completed = task.isTaskCompleted();
      // changing completeness state of the task
      task.setTaskCompleted(!completed);`,
      `
      Allows to change archiveness of the task. If the object
      is not a task then this function has no effect.`,
      `
      Позволяет менять состояние архивированности задачи. Если объект
      не является задачей, то ничего не происходит при вызове этой функции.`
    ),
    new HelpNode(
      'getTaskCompletionTime',
      'getTaskCompletionTime()',
      `
      Items.get('... task id').getTaskCompletionTime();`,
      `
      const task = Items.get('...');
      const completed = task.getTaskCompletionTime();`,
      `Returns time of task completion (Unix timestamp).`,
      `Возвращает время архивирования задачи (Unix timestamp).`
    ),
    new HelpNode(
      'setMirror',
      'setMirror(columns)',
      `
      Items.get('... column id').setMirror([]);`,
      `
      var column = Items.get('...');
      var board = Items.get('...');
      // making “column” to be a mirror
      // of all columns inside “board”
      column.setMirror(board.list());

      // making the column to be an ordinary
      // column again (not a mirror)
      column.setMirror([]);`,
      `Sets a column as a mirror for another columns.`,
      `Сделать колонку зеркалом других колонок.`
    ),
    new HelpNode(
      'isMirror',
      'isMirror()',
      `
      Items.get('... column id').isMirror();`,
      `
      var column = Items.get('...');
      column.isMirror();`,
      `Returns true is this is a mirror colun.`,
      `Возвращает true если объект являетя зеркальной колонкой.`
    ),
    new HelpNode(
      'isReport',
      'isReport()',
      `
      Items.get('... column id').isReport();`,
      `
      var column = Items.get('...');
      column.isReport();`,
      `Returns true is this is a report colun.`,
      `Возвращает true если объект являетя колонкой с отчётом.`
    ),
    new HelpNode(
      'listMirrored',
      'listMirrored()',
      `
      Items.get('... column id').listMirrored();`,
      `
      var column = Items.get('...');
      var mirrored = column.listMirrored();
      // checking if the column is mirror
      if (mirrored.length > 0) {
       // column is a mirror for some other columns
      }`,
      `Returns an array of mirrored columns.`,
      `Возвращает массив отзеркалированных колонок.`
    )
  ]
  const itemHelp = new HelpNode(
    'Item',
    'item variable',
    `Items.get('... id');`,
    `
    var x = Items.get('... object id here');
    // variable “x” is an item variable,
    // and we can access all its properties
    Notifier.success('Object name is ' + x.name);

    // x is either project, board, column or task and you can find out it
    // by accessing a type property (x.type), possible values are: Task, Column,
    // Board, Project, Company
    if (x.type === 'Task') {
      // do something if “x” is a task
    }

    // any object is inside some hierarchical structure: tasks are inside
    // columns, columns are inside boards, boards inside projects and projects
    // inside Company.
    // You can access a parent object by calling .up()
    x.up(); // gets the parent object which is also an item variable
    x.up().name; // the name of parent object
    // and we can also do this
    x.up().up().name; // the name of objects grandparent

    // to get all the child objects of some object .list() method is used
    x.list(); // if object is a column then we get here array of its tasks

    // if you want to get all tasks inside a board then you can write
    if (x.type === 'Board') {
      var all = [];
      x.list().forEach(function (col) { // for each column inside x
        col.list().forEach(function (t) { // for each task inside col
          // adding task “t” to the “all” array
          all.push(t);
        });
      });
      // now “all” variable contains all tasks inside board “x”
    }`,
    `
    Variable representing some YouGile object (task, column, board or project).
    Can be get by calling Items.get(...) (or by using Object navigator).`,
    `
    Переменная представляющая задачу, колонку, доску или проект.
    Может быть получена вызовом функции Items.get(...)
    (или через Навигатор по объектам).`,
    itemFields
  )

  const stickersFields = [
    new HelpNode(
      'getAll',
      'getAll()',
      `
      Stickers.getAll();`,
      `var allSt = Stickers.getAll();`,
      `
      Get all stickers that are available in company including system stickers:
      Timer, Deadline, Stopwatch, User.
      System stickers can’t be changed, but other stickers can be modified
      or deleted.`,
      `
      Получает все стикеры, доступные в компании, включая системные стикеры:
      Таймер, Дедлайн, Секундомер и Юзер.
      Системные стикеры не могут быть изменениы, но остальные стикеры могут
      быть модифицированы или удалены.`
    ),
    new HelpNode(
      'get',
      'get(name)',
      `
      Stickers.get('');`,
      `
      var p = Stickers.get('Priority');
      // now p is a sticker variable,
      // so we can add a new value to the sticker
      p.setData('High', {color: '#f00'});`,
      `
      Gets a sticker by its name. There not only user-defined stickers
      but also system stickers: 'User', 'Deadline', 'Timer', 'Stopwatch'.`,
      `
      Возвращает стикер по его названию. Кроме пользовательских
      стикеров есть ещё встроенные системные стикеры, их имена:
      'User', 'Deadline', 'Timer', 'Stopwatch' — они также могут
      быть получены вызовом Stickers.get.`
    ),
    new HelpNode(
      'create',
      'create(name)',
      `
      Stickers.create('...');`,
      `
      var sticker = Stickers.create('Some sticker');
      var board = Items.get('...');
      Stickers.addToBoard(board, sticker);
      sticker.addState('one');
      sticker.addState('two');
      sticker.setData('one', {color: '#00f'});`,
      `Creates a new text sticker.`,
      `Создание нового текстового стикера.`
    ),
    new HelpNode(
      'pin',
      'pin(task, sticker, value)',
      `
      Stickers.pin(, , );`,
      `
      // getting task
      var t = Items.get('ae2ba67f-b6b8-4498-b209-b3db42829b83');
      // getting sticker
      var s = Stickers.get('Priority');
      // adding sticker to the task with value “Major”
      Stickers.pin(t, s, 'Major');`,
      `
      Adds the sticker with value to the specified task.
      If you want to add sticker, but don’t want to specify
      a value, then you can call the Sticker.pin without 3-rd argument.

      You can also change the sticker pinned value of the task if the sticker
      is already pinned to the task.`,
      `
      Добавляет стрикер со значением к конкретной задаче.
      Если вы хотите добавить стикер, но не хотите указывать значение,
      мы можете вызвать Sticker.pin без третьего аргумента.`
    ),
    new HelpNode(
      'unpin',
      'unpin(task, sticker)',
      `
      Stickers.unpin(, );`,
      `
      // getting task
      var t = Items.get('ae2ba67f-b6b8-4498-b209-b3db42829b83');
      // getting sticker
      var s = Stickers.get('Priority');
      // removing sticker from task
      Stickers.unpin(t, s);`,
      `Removes the sticker from the specified task.`,
      `Убирает стикер из указанной задачи.`
    ),
    new HelpNode(
      'isPinned',
      'isPinned(task, sticker)',
      `
      Stickers.isPinned(, );`,
      `
      // getting task
      var t = Items.get('ae2ba67f-b6b8-4498-b209-b3db42829b83');
      // getting sticker
      var s = Stickers.get('Priority');
      if (Stickers.isPinned(t, s)) {
        Notifier.success('Priority is pinned to the task!');
      }`,
      `Returns true if sticker is pinned to the task.`,
      `Возвращает true если стикер прикреплен к задаче`
    ),
    new HelpNode(
      'getValue',
      'getValue(task, sticker)',
      `
      Stickers.getValue(, );`,
      `
      // getting task
      var t = Items.get('ae2ba67f-b6b8-4498-b209-b3db42829b83');
      // getting sticker
      var s = Stickers.get('Priority');
      if (Stickers.getValue(t, s) === 'Major') {
        Notifier.warn('Task is of Major priority!');
      }`,
      `Gets the value of the sticker pinned to task.`,
      `Получает значение стикера, прикрепленного к задаче.`
    ),
    new HelpNode(
      'getDeadline',
      'getDeadline(task)',
      `
      Stickers.getDeadline(Items.get('...'));`,
      `
      var task = Items.get('...');
      const dl = Stickers.getDeadline(task);
      if (dl) {
        console.log('Deadline is set to ' + App.formatDateTime(dl.timestamp));
      }`,
      `
      Gets a deadline associated with the task, in format of object
      {timestamp: number, withTime: boolean}, where timestamp is
      a server UNIX-timestamp (see App.time()) and withTime tells
      if specific time of deadline is set or just day is specified.
      Returns undefined if deadline is not set.`,
      `
      Возвращает дедлайн на задаче в формате
      {timestamp: number, withTime: boolean},
      где timestamp – UNIX-timestamp сервера (см. App.time()), а withTime
      показывает, что установлен не только день дедлайна, но и время.
      Если дедлайн на задаче не установлен, возвращает undefined.`
    ),
    new HelpNode(
      'getDeadlineHistory',
      'getDeadlineHistory(task)',
      `
      Stickers.getDeadlineHistory(Items.get('...'));`,
      `
      var task = Items.get('...');
      const dlHistory = Stickers.getDeadlineHistory(task);
      if (dlHistory) {
        console.log('Deadline history');
        dlHistory.forEach(dl =>
          console.log(
            'User ' + dl.user.name + ' set deadline to ' +
            App.formatDateTime(dl.timestamp)
          )
        );
      }`,
      `
      Gets a deadline history associated with the task, in format of object
      array of objects:
      {timestamp: number, withTime: boolean, user: UserObj},
      where timestamp is
      a server UNIX-timestamp (see App.time()) and withTime tells
      if specific time of deadline is set or just day is specified and
      user is the user who set the deadline.
      Returns undefined if deadline is not set.`,
      `
      Возвращает историю дедлайна на задаче в формате массива из объектов вида:
      {timestamp: number, withTime: boolean, user: UserObj},
      где timestamp – UNIX-timestamp сервера (см. App.time()), а withTime
      показывает, что установлен не только день дедлайна, но и время,
      user – пользователь установивший дедлайн.
      Если дедлайн на задаче не установлен, возвращает undefined.`
    ),
    new HelpNode(
      'getDeadlineLinks',
      'getDeadlineLinks(task)',
      `
      Stickers.getDeadlineLinks(Items.get('...'));`,
      `
      var task = Items.get('...');
      Stickers.getDeadlineLinks(task);`,
      `Get link task ids.`,
      `Получает список id задач, которые связаны с помощью дедлайна (кейс Ганта).`
    ),
    new HelpNode(
      'setDeadline',
      'setDeadline(task, timestamp, withTime, startDate, byYougileUser)',
      `
      Stickers.setDeadline(Items.get('...'), App.time() + 60601000, true);`,
      `
      var task = Items.get('...');
      // set deadline to now + 1 minute
      Stickers.setDeadline(task, App.time() + 60000, true);
      // remove the deadline
      Stickers.setDeadline(task, undefined);`,
      `Sets a deadline. If timestamp is not specified, then deadline is removed.`,
      `
      Устанавливает дедлайн. Если timestamp не указан, то дедлайн снимается
      с задачи.`
    ),
    new HelpNode(
      'getFilterValue',
      'getFilterValue(board, sticker)',
      `
      Stickers.getFilterValue(, );`,
      ``,
      `
      Returns the current value by which board is filtered with the
      specified sticker.`,
      `
      Возвращает текущее значение, по которому фильтруется доска с
      указанным стикером.`
    ),
    new HelpNode(
      'getAllFilters',
      'getAllFilters(board)',
      `
      Stickers.getAllFilters();`,
      ``,
      `Gets all stickers that are currently filtering the specified board.`,
      `Возвращает все стикеры, которые в данный момент фильтруют доску.`
    ),
    new HelpNode(
      'setFilter',
      'setFilter(board, sticker, value)',
      `
      Stickers.setFilter(, , );`,
      `
      // getting board
      var b = Items.get('…');
      var s = Stickers.get('Priority');
      Stickers.setFilter(b, s, 'Major');`,
      `
      Filter a boards with the specified value of the sticker (only show
      such tasks that have the specified value of the sticker).`,
      `
      Фильтрует доску с указанным значением стикера (покажет только
      такие задачи, которые имеют указанное значение стикера).`
    ),
    new HelpNode(
      'removeFilter',
      'removeFilter(board, sticker)',
      `
      Stickers.removeFilter(, );`,
      ``,
      `Remove filter by the specified sticker from the board.`,
      `Убирает фильтрацию доски по указанному стикеру.`
    ),
    new HelpNode(
      'getAllInBoard',
      'getAllInBoard(board)',
      `
      Stickers.getAllInBoard();`,
      ``,
      `Gets all stickers available in sticker panel of the board.`,
      `Получает все стикеры, доступные в панели стикеров доски.`
    ),
    new HelpNode(
      'isInBoard',
      'isInBoard(board, sticker)',
      `
      Stickers.isInBoard(, );`,
      ``,
      `Returns true if the specified sticker is added to the board.`,
      `Возвращает true, если указанный стикер добавлен в доску.`
    ),
    new HelpNode(
      'addToBoard',
      'addToBoard(board, sticker)',
      `
      Stickers.addToBoard(, );`,
      ``,
      `Adds the sticker to the sticker panel of the specified board.`,
      `Добавляет стикер в панель стикеров указанной доски.`
    ),
    new HelpNode(
      'removeFromBoard',
      'removeFromBoard(board, sticker)',
      `
      Stickers.removeFromBoard(, );`,
      ``,
      `Remove the sticker from the sticker panel of the board.`,
      `Убирает стикер из панели стикеров доски.`
    ),
    new HelpNode(
      'onBoardFilterChange',
      'onBoardFilterChange() => void)',
      `
      Stickers.onBoardFilterChange = function () {
      };`,
      `
      Stickers.onBoardChange = function () {
        var board = Current.board;
        var stickers = Stickers.getAllFilters(board);

        Notifier.success(
          'Фильтрация доски изменена, ' +
          'доска ' + board.name + ' фильтрация по: ' +
          stickers.map(s => s.name).join()
        );
      };`,
      `This function is called when user changes board filter stickers.`,
      `
      Функция вызывается когда пользователь меняет
      фильтр доски (меняет состояние стикера в панели стикеров).`
    ),
    new HelpNode(
      'onPin',
      'onPin(task, sticker, value)',
      `
      Stickers.onPin = function (task, sticker) {
        return true;
      };`,
      `
      Stickers.onPin = function (task, sticker) {
        var value = Stickers.getValue(task, sticker);
        if (sticker.name === 'Priority' && value === 'Major') {
          Notifier.warn('You shouldn’t add this priority!');
          return false; // prevent adding sticker
        } else {
          return true; // default action
        }
      };`,
      `
      This function is called when user tries to pin sticker to some task.
      If this function returns false, then the action is prevented.`,
      `
      Эта функция вызывается когда пользователь добавляет стикер на задачу.
      Если функция возвращает false, действие отменяется.`
    ),
    new HelpNode(
      'onUnpin',
      'onUnpin(task, sticker)',
      `
      Stickers.onUnpin = function (task, sticker) {
        return true;
      };`,
      `
      Stickers.onUnpin = function (task, sticker) {
        if (!Current.user.isAdmin) {
          return false; // disallow unpinning if not admin
        }
      }`,
      `
      This function is called when user tries to unpin sticker from some task.
      If this function returns false, then the action is prevented.`,
      `
      Эта функция вызывается когда пользователь убирает стикер с задачи.
      Если функция возвращает false, действие отменяется.`
    )
  ]
  const stickersHelp = new HelpNode(
    'Stickers',
    'Stickers',
    `Stickers`,
    '',
    `Allows to manipulate stickers.`,
    `Позволяет управлять стикерами.`,
    stickersFields
  )

  const stickerObjFields = [
    new HelpNode(
      'name',
      'name',
      `
      Stickers.get('... sticker’s name').name;`,
      ``,
      `Return a name of a sticker.`,
      `Возвращает имя стикера.`
    ),
    new HelpNode(
      'type',
      'type',
      `
      Stickers.get('... sticker’s name').type;`,
      ``,
      `
      Returns a type of a sticker. Possible types are: Text, Sprint, Deadline,
      Timer, User.`,
      `
      Возвращает тип стикера. Возможные типы: Text, Sprint, Deadline,
      Timer, User.`
    ),
    new HelpNode(
      'states',
      'states',
      `
      Stickers.get('... sticker name here').states;`,
      `
      var priority = Stickers.get('Priority');
      var states = priority.states;
      var firstState = states[0]; // 'Minor'
      var color = priority.getData(firstState).color;`,
      `
      Returns an array of all sticker states. Sticker state is a string that is
      specified when sticker is added to a task. For example if there is
      Priority sticker then its states can be
      'Major', 'Normal', 'Minor', … and tasks that
      have this sticker are not only have it pinned but also have a specific
      state set.`,
      `
      Возвращает массив всех состояний стикера. Состояние стикера
      задаётся строкой с его именем, к состоянию также может быть
      прикреплена дополнительная информация (напр. цвет) эта
      информация может быть получена через функцию .getData()`
    ),
    new HelpNode(
      'addState',
      'addState(name)',
      `
      Sticker.get('... sticker’s name').addState('... state name');`,
      `
      var s = Stickers.get('Priority');
      // adding a new state to “Priority” sticker
      s.addState('Super important!');

      // now we also can add a color to this new state
      s.setData('Super important!', '#f00'); // let it be red for example`,
      `Adds a state to the sticker.`,
      ``
    ),
    new HelpNode(
      'removeState',
      'removeState(name)',
      `
      Sticker.get('... sticker name').removeState('??? state name');`,
      `
      var s = Stickers.get('Priority');
      // suppose, we don’t want this “Critical” state anymore
      s.removeState('Critical');`,
      `Removes a state from the sticker.`,
      ``
    ),
    new HelpNode(
      'getData',
      'getData(name)',
      `
      Stickers.get('... sticker name here').getData('??? sticker state');`,
      ``,
      `
      Returns an additional data, associated with the sticker state
      (for Text sticker it is color, for sprint sticker it is dates).`,
      `
      Возвращает дополнительные данные, связанные со значением стикера.
      (для текстового стикера – цвет, для стикера Спринт – даты).`
    ),
    new HelpNode(
      'setData',
      'setData(name, data)',
      `
      Stickers.get('... sticker name here').getData({});`,
      `
      var st = Stickers.get('Priority');
      // we want to change a color of “Normal” state to blue
      st.setState('Normal', {color: '#00f'});`,
      `Change data associated with the sticker state`,
      ``
    ),
    new HelpNode(
      'getHistory',
      'getHistory(task)',
      `
      var task = Items.get('...');
      Stickers.get('Timer|Stopwatch').getHistory(task);`,
      `
      var task = Items.get('...');
      var timer = Stickers.get('Timer');
      var hist = timer.getHistory(task);
      // hist is an array of objects`,
      `
      Gets a history of state changes from Timer or Stopwatch stickers
      in some task.`,
      `
      Получает историю изменений состояний для стикеров Timer (таймер)
      или Stopwatch (секундомер) в определённой задаче.`
    ),
    new HelpNode(
      'clearHistory',
      'clearHistory(task)',
      `
      var task = Items.get('...');
      Stickers.get('Timer|Stopwatch').clearHistory(task);`,
      `
      var task = Items.get('...');
      var timer = Stickers.get('Timer');
      var hist = timer.clearHistory(task);`,
      `
      Remove the history of state changes of Timer or Stopwatch sticker
      from the task.`,
      `
      Очищает историю изменений состояний для стикеров Timer (таймер)
      или Stopwatch (секундомер) в определённой задаче.`
    ),
    new HelpNode(
      'changeTime',
      'changeTime(task, time)',
      `
      var task = Items.get('...');
      Stickers.get('Timer|Stopwatch').changeTime(task, '2h30m');`,
      `
      var task = Items.get('...');
      var timer = Stickers.get('Timer');
      timer.changeTime(task, '1d5h');`,
      `Sets a time for stickers Timer and Stopwatch.`,
      `Устанавливает время для стикеров Timer и Stopwatch.`
    ),
    new HelpNode(
      'start',
      'start(task, time)',
      `
      var task = Items.get('...');
      Stickers.get('Timer|Stopwatch').start(task);`,
      `
      var task = Items.get('...');
      var timer = Stickers.get('Timer');
      timer.start(task, '1d');

      var stopwatch = Stickers.get('Stopwatch');
      stopwatch.start(task);`,
      `Starts Timer or Stopwatch on the specified task.`,
      `Запускает Timer или Stopwatch на указанной задаче.`
    ),
    new HelpNode(
      'stop',
      'stop(task)',
      `
      var task = Items.get('...');
      Stickers.get('Timer|Stopwatch').stop(task);`,
      `
      var task = Items.get('...');
      var timer = Stickers.get('Timer');
      timer.stop(task);

      var stopwatch = Stickers.get('Stopwatch');
      stopwatch.stop(task);`,
      `Stops Timer or Stopwatch on the specified task.`,
      `Останавливает Timer или Stopwatch на указанной задаче.`
    )
  ]
  const stickerObjHelp = new HelpNode(
    'StickerObj',
    'sticker variable',
    `Stickers.get('... sticker name');`,
    `
    var st = Stickers.get('Priority');
    // st is a sticker variable now`,
    `
    Represents a sticker. You can get this variable from Stickers.get
    function.`,
    `
    Переменная, представляющая стикер. Можно получить переменную со стикером
    вызвав функцию Stickers.get(...)`,
    stickerObjFields
  )

  const chatFields = [
    new HelpNode(
      'close',
      'close()',
      `
      Chat.close();`,
      `Chat.close();`,
      `Closes currently opened chat if it is opened`,
      `Закрывает текущий открытый чат.`
    ),
    new HelpNode(
      'open',
      'open(task)',
      `
      Chat.open(Items.get('... task id'));`,
      ``,
      `Opens a chat for the specified task.`,
      `Открывает чат указанной задачи.`
    ),
    new HelpNode(
      'listMessages',
      'listMessages(task)',
      `
      Chat.listMessages(Items.get('... task id'));`,
      `
      var task = Items.get('... task id');
      var messages = Chat.listMessages(task);
      console.log('First message', message[0]);`,
      `Returns an array of all messages in chat.`,
      `Возвращает массив всех сообщений в чате.`
    ),
    new HelpNode(
      'postMessage',
      'postMessage(task, from, text, label)',
      `
      Chat.postMessage(Items.get('...'), Users.get('...'), '... text');`,
      `
      var task = Items.get('...');
      // sending service message (empty sender)
      Chat.postMessage(task, '', 'Hello');

      // sending message from some user
      Chat.postMessage(task, Users.get('...'), 'Hello!');`,
      `Posts a message to the specified chat.`,
      `Отправляет сообщение в чат по задаче.`
    ),
    new HelpNode(
      'getDescription',
      'getDescription(task)',
      `
      Chat.getDescription(Items.get('...'));`,
      ``,
      `Gets chat description string. Generally it is html-string.`,
      `Возвращает строку с описанием к задаче (html-строка).`
    ),
    new HelpNode(
      'setDescription',
      'setDescription(task, text)',
      `
      Chat.setDescription(Items.get('...'), '... html string');`,
      ``,
      `
      Sets a new description for a task’s chat. HTML-string can
      be passed.`,
      `
      Устанавливает описание к задаче. Можно передавать HTML-строку
      как параметр.`
    ),
    new HelpNode(
      'getSubtasks',
      'getSubtasks(task)',
      `
      Chat.getSubtasks(Items.get('...'));`,
      `
      var task = Items.get('...');
      var todoLists = Chat.getSubtasks(task);
      console.log(todoLists);
      // result:
      // [
      //   {
      //     id: '...',
      //     title: 'Todo list 1',
      //     items: [
      //       {
      //         id: '...',
      //         isCompleted: false,
      //         title: 'Todo item 1'
      //       }
      //     ]
      //   }
      // ]
      //`,
      `Gets all subtask lists with their items as a JSON object.`,
      `
      Возвращает списки чеклистов со всеми их пунктами в виде
      JSON-объекта.`
    ),
    new HelpNode(
      'setSubtasks',
      'setSubtasks(task, subtasks)',
      `
      Chat.setSubtasks(Items.get('...'), [...]);`,
      `
      var task = Items.get('...');
      var todoLists = Chat.getSubtasks(task);
      var firstTodoList = todoLists[0];
      var newTask = {
        title: 'Do something…'
      };
      firstTodoList.items.push(newTask);
      // updating todo lists
      Chat.setSubtasks(task, todoLists);`,
      `Sets all subtask lists for the specified task.`,
      `Позволяет установить списки чеклистов для выбранной задачи.`
    ),
    new HelpNode(
      'addUser',
      'addUser(task, user)',
      `
      Chat.addUser(Items.get('... task id'), Users.get('...'));`,
      ``,
      `Adds user to a chat.`,
      `Добавляет пользователя в чат.`
    ),
    new HelpNode(
      'removeUser',
      'removeUser(task, user)',
      `
      Chat.removeUser(Items.get('... task id'), Users.get('...'));`,
      ``,
      `Removes user from chat.`,
      `Убирает пользователя из чата.`
    ),
    new HelpNode(
      'listUsers',
      'listUsers(task)',
      `
      Chat.listUsers(Items.get('... task id'));`,
      ``,
      `Returns an array of all notified users in the specified chat.`,
      `
      Возвращает массив всех пользователей в чате (получающих
      уведомления по указанному чату).`
    ),
    new HelpNode(
      'isUserInChat',
      'isUserInChat(task, user)',
      `
      Chat.isUserInChat(Items.get('... task id'), Users.get('...'));`,
      ``,
      `Returns true if the user is in the chat.`,
      `Возвращает true если пользователь добавлен в чат.`
    ),
    new HelpNode(
      'scrollBottom',
      'scrollBottom()',
      `
      Chat.scrollBottom();`,
      ``,
      `Scrolls an opened chat to bottom.`,
      `Прокручивает открытый чат в конец.`
    ),
    new HelpNode(
      'scrollTop',
      'scrollTop()',
      `
      Chat.scrollTop();`,
      ``,
      `Scrolls opened chat to top.`,
      `Прокручивает открытый чат в начало.`
    ),
    new HelpNode(
      'markRead',
      'markRead(task, user)',
      `
      Chat.markRead(Items.get('... task id'));`,
      ``,
      `Marks all messages in the chat as read.`,
      `Отмечает все сообщения в чате по задаче как прочитанные.`
    ),
    new HelpNode(
      'onPostMessage',
      'onPostMessage(message)',
      `
      Chat.onPostMessage = function (message) {
      };`,
      `
      Chat.postMessage = function (message) {
        message.text += '!!!';
      }`,
      `This function is called when user added a message to a chat.`,
      `
      Эта функция вызывается, когда пользователь добавил
      сообщение в чат.`
    ),
    new HelpNode(
      'onBeforePostMessage',
      'onBeforePostMessage(task, text)',
      `
      Chat.onBeforePostMessage = function (task, text) {
        return true;
      };`,
      ``,
      `
      This function is called when user posts a message and before
      message is added to the chat. If it returns false, then
      message is not added.`,
      `
      Эта функция вызывается, когда пользователь отправляет сообщение,
      но до того, как оно добавляется в чат. Если функция вернёт
      false, то сообщение не добавится в чат.`
    ),
    new HelpNode(
      'getOpenedChatId',
      'getOpenedChatId()',
      `
      Chat.getOpenedChat();`,
      ``,
      `Returns an opened chat.`,
      `Возвращает открытый чат.`
    ),
    new HelpNode(
      'onChatChange',
      'onChatChange(id)',
      `
      Chat.onChatChange = function (id) {}`,
      ``,
      `This function is called when the opened chat is changed.`,
      `Эта функция вызывается, когда открытый чат изменяется.`
    ),
    new HelpNode(
      'onOpen',
      'onOpen() => void)',
      `
      `,
      ``,
      `Not implemented!
      `,
      `Not implemented!
      `
    ),
    new HelpNode(
      'onClose',
      'onClose() => void)',
      `
      `,
      ``,
      `Not implemented!
      `,
      `Not implemented!
      `
    ),
    new HelpNode(
      'allowDescription',
      'allowDescription() => void)',
      `
      `,
      ``,
      `Not implemented!
      `,
      `Not implemented!
      `
    ),
    new HelpNode(
      'allowChat',
      'allowChat() => void)',
      `
      `,
      ``,
      `Not implemented!
      `,
      `Not implemented!
      `
    ),
    new HelpNode(
      'allowEditDescription',
      'allowEditDescription() => void)',
      `
      `,
      ``,
      `Not implemented!
      `,
      `Not implemented!
      `
    ),
    new HelpNode(
      'allowPostMessages',
      'allowPostMessages() => void)',
      `
      `,
      ``,
      `Not implemented!
      `,
      `Not implemented!
      `
    ),
    new HelpNode(
      'onDescriptionChange',
      'onDescriptionChange() => void)',
      `
      `,
      ``,
      `Not implemented!
      `,
      `Not implemented!
      `
    ),
    new HelpNode(
      'onReadMessage',
      'onReadMessage() => void)',
      `
      `,
      ``,
      `Not implemented!
      `,
      `Not implemented!
      `
    ),
    new HelpNode(
      'onKeyDown',
      'onKeyDown() => void)',
      `
      `,
      ``,
      `Not implemented!
      `,
      `Not implemented!
      `
    ),
    new HelpNode(
      'onKeyUp',
      'onKeyUp() => void)',
      `
      `,
      ``,
      `Not implemented!
      `,
      `Not implemented!
      `
    )
  ]
  const chatHelp = new HelpNode(
    'Chat',
    'Chat',
    `Chat`,
    '',
    `Allows to manipulate tasks’ chats.`,
    `Позволяет управлять чатами задач.`,
    chatFields
  )

  const messageObjFields = [
    new HelpNode(
      'timestamp',
      'timestamp',
      `
      (...).timestamp;`,
      ``,
      `Unit timestamp of message creation.`,
      `Время отправки сообщения (unix timestamp).`
    ),
    new HelpNode(
      'from',
      'from',
      `
      (...).from;`,
      ``,
      `Sender user.`,
      `Отправитель сообщения.`
    ),
    new HelpNode(
      'text',
      'text',
      `
      (...).text;`,
      ``,
      `Message text.`,
      `Текст сообщения.`
    ),
    new HelpNode(
      'deleted',
      'deleted',
      `
      (...).deleted;`,
      ``,
      `True if message is deleted.`,
      `Удалено ли сообщение.`
    ),
    new HelpNode(
      'ui',
      'ui',
      `
      (...).ui;`,
      `
      var task = Items.get('... some task id');
      // getting a first message
      var m = Chat.listMessages(task)[0];
      m.ui.style = {
        background: '#ff0'
      };`,
      ``,
      ``
    ),
    new HelpNode(
      'getTask',
      'getTask()',
      `
      (...).getTask();`,
      ``,
      `Gets the corresponding task.`,
      `Возвращает соответствующую задачу.`
    ),
    new HelpNode(
      'getData',
      'getData()',
      `
      (...).getData();`,
      ``,
      `Gets custom data attached to the message (see setData function).`,
      `
      Получает пользовательские данные, прикрепленные к сообщению.
      (см. функцию setData).`
    ),
    new HelpNode(
      'setData',
      'setData(val)',
      `
      (...).setData(...);`,
      ``,
      `
      Custom data can be attached to any message
      (JSON). This data is automatically
      synchronized with server and all users and if available
      with getData function.`,
      `
      К любому объекту YouGile можно добавить пользовательские
      данные (JSON). Они будут автоматически синхронизированы
      с сервером и всеми юзерами и доступны через
      функцию getData.`
    )
  ]
  const messageObjHelp = new HelpNode(
    'MessageObj',
    'message variable',
    `Chat.listMessages(Items.get('... task id'));`,
    '',
    `
    Representation of a message in a tasks’s chat
    (see Chat.listMessages).`,
    `
    Переменная представляеющая сообщение в чате по задаче
    (см. Chat.listMessages).`,
    messageObjFields
  )

  const textsFields = [
    new HelpNode(
      'ru',
      'ru',
      `
      Texts.ru`,
      `Texts.ru.projects = 'Отделы';`,
      `Allows get and change language strings.`,
      `Позволяет получать и изменять строки в системе.`
    ),
    new HelpNode(
      'en',
      'en',
      `
      Texts.en`,
      `Texts.en.projects = 'Departments';`,
      `Allows get and change language strings.`,
      `Позволяет получать и изменять строки в системе.`
    )
  ]
  const textsHelp = new HelpNode(
    'Texts',
    'Texts',
    `Texts`,
    '',
    `Getting and changing application interface texts.`,
    `Получает и изменяет тексты интерфейса приложения.`,
    textsFields
  )

  const uiFields = [
    new HelpNode(
      'onRender',
      'onRender(object)',
      `
      `,
      ``,
      `Not implemented!
      `,
      `Not implemented!
      `
    ),
    new HelpNode(
      'onDestroy',
      'onDestroy(object)',
      `
      `,
      ``,
      `Not implemented!
      `,
      `Not implemented!
      `
    ),
    new HelpNode(
      'components',
      'components',
      `
      UI.components.chat.style = {
      };`,
      `
      // chat window contents
      UI.components.chat;

      // panel of stickers in board
      UI.components.stickerPanel;`,
      `
      Collection of user interface components of the system
      (see usage example below).`,
      `Набор компонентов интерфейса системы (см. примеры использования ниже).`
    ),
    new HelpNode(
      'background',
      'background',
      `
      UI.background = '... url';`,
      `
      // custom background for a particular board example

      // getting the board
      var board = Items.get('... board id');
      // custom image
      var img =
        '/user-data/10c3ddff-ce6a-43a0-8fbb-3e1d6ba3a245/my-image.jpg';
      // to get its url you can upload it to YouGile
      // set it as a background and call console.log(UI.background);

      // we need to set the background at the start of the script…
      if (Current.board.id === board.id) {
        UI.background = img;
      } else {
        UI.background = ''; // set default for other boards
      }

      // …and also change the background if user navigates to
      // another board
      Current.onBoardChange = function (oldBoard, newBoard) {
        if (newBoard && newBoard.id === board.id) {
          UI.background = img;
        } else {
          UI.background = ''; // set default for other boards
        }
      };`,
      `
      Allows to set a custom background. Background should be
      loaded to YouGile.
      To set a background you should specify relative url.
      If background is set to empty string then it returns to its default.`,
      `
      Позволяет устанавливать свой фон. Фон должен быть загружен в YouGile.
      Чтобы установить фон, вы должны указать соответствующий url.
      Если указывается пустая строка, то фон возвращается к установленному
      по умолчанию.`
    ),
    new HelpNode(
      'text',
      'text(value)',
      `
      UI.text('...');`,
      `
      var t = Items.get('... task id');
      var txt = UI.text('Some text…');
      txt.style.color = 'red';
      t.ui.add(txt);

      // we can also change the text of this label
      t.ui.onClick = function () {
        txt.text = 'Clicked!';
        txt.style.color = '#0c0';
      }`,
      `Creates a text label element.`,
      `Создает элемент "текст".`
    ),
    new HelpNode(
      'button',
      'button(props)',
      `
      UI.button({ title: '...', size: 'sm', color: 'primary' });`,
      `
      var t = Items.get('... task id');
      var btn = UI.button({
        title: 'Submit',
        size: 'lg',
        color: 'secondary',
        icon: 'IconCustomTimer',
        hint: 'Click to submit'
      });
      btn.style.backgroundColor = 'green';
      t.ui.add(btn);

      // Add event handling for the button
      btn.onClick = function (e) {
        console.log('Button clicked', e);
      }

      // Change button state on mouse down
      btn.onMouseDown = function (e) {
        btn.title = 'Pressed';
      }`,
      `Creates a customizable button element with various properties like icon, title, size, color, and event handlers.`,
      `Создает кнопку с различными свойствами, такими как иконка, заголовок, размер, цвет.`
    ),
    new HelpNode(
      'checkbox',
      'checkbox(props, e)',
      `
      const checkbox = UI.checkbox({ value: true });`,
      `
      // Basic checkbox
      const checkbox = UI.checkbox({ value: true });

      // Checkbox with label, footnote, and color options
      const checkbox = UI.checkbox({
        value: true,
        onChange: (newValue) => console.log('Checkbox state changed:', newValue),
        label: 'Accept Terms',
        footnote: 'You must accept terms to continue',
        color: 'blue',
        rounded: true
      });`,
      `
      Creates a checkbox with customizable options for appearance and behavior.
      Optional properties can be provided in the props parameter:
      - value (boolean): Initial checked state of the checkbox.
      - onChange (function): Callback function triggered on state change. Receives the new value
        and an optional event (MouseEvent or KeyboardEvent).
      - disabled (boolean): If true, the checkbox is disabled and cannot be interacted with.
      - error (boolean): If true, displays the checkbox in an error state.
      - label (React.ReactNode): Text or element label displayed beside the checkbox.
      - footnote (React.ReactNode): Footnote displayed below the checkbox for additional context.
      - renderFullFootnote (boolean): If true, renders the footnote in full width below the checkbox.
      - className (string): Additional CSS class for styling the checkbox wrapper.
      - labelClassName (string): Additional CSS class for styling the label.
      - dataTestId (string): ID for testing purposes.
      - color ('green' | 'blue' | 'gray'): Color theme of the checkbox.
      - rounded (boolean): If true, renders the checkbox with rounded edges.
      - size (CheckboxSize): Size of the checkbox; available options are defined in CheckboxSize.`,
      `
      Создает флажок с возможностью настройки внешнего вида и поведения.
      Дополнительные параметры можно передать в объекте props:
      - value (boolean): Начальное состояние флажка (отмечен или нет).
      - onChange (function): Обработчик события изменения состояния, получает новое значение value
        и необязательный объект события (MouseEvent или KeyboardEvent).
      - disabled (boolean): Если true, флажок отключен и не доступен для взаимодействия.
      - error (boolean): Если true, флажок отображается в состоянии ошибки.
      - label (React.ReactNode): Текст или элемент, отображаемый рядом с флажком.
      - footnote (React.ReactNode): Пояснение под флажком.
      - renderFullFootnote (boolean): Если true, пояснение отображается на всю ширину под флажком.
      - className (string): Дополнительный CSS-класс для обертки флажка.
      - labelClassName (string): Дополнительный CSS-класс для метки.
      - dataTestId (string): ID для целей тестирования.
      - color ('green' | 'blue' | 'gray'): Цветовая тема флажка.
      - rounded (boolean): Если true, флажок отображается с закругленными краями.
      - size (CheckboxSize): Размер флажка, возможные значения определены в CheckboxSize.`
    ),
    new HelpNode(
      'icon',
      'icon(icon)',
      `
      const myIcon = UI.icon({ icon: 'star' });`,
      `
      // Basic icon
      const myIcon = UI.icon({ icon: 'star' });

      // Icon with custom color, size, and tooltip
      const myIcon = UI.icon({
        icon: 'star',
        color: 'blue',
        size: 24,
        title: 'Favorite',
        hint: 'Click to add to favorites'
      });
      `,
      `
      Creates an icon with customizable appearance and behavior. Optional properties
      can be provided in the icon parameter:
      - color (keyof typeof allColors): Sets the color of the icon from the available color palette.
      - size (12 | 16 | 20 | 24 | 32): Specifies the icon size in pixels.
      - type (IconType): Specifies the type of the icon, allowing for different styles or designs.
      - icon (TablerIcons): Required. Specifies the icon from the available TablerIcons set.
      - className (string): Adds a custom CSS class for styling the icon element.
      - title (string): Provides a title for accessibility, displayed as a tooltip on hover.
      - hint (ReactNode): Additional hint or tooltip displayed on hover for more context.
      - style (CSSProperties): Applies inline styles directly to the icon.
      - onClick ((e: React.MouseEvent) => void): Callback function triggered when the icon is clicked, receiving the event as an argument.
      `,
      `
      Создает иконку с возможностью настройки внешнего вида и поведения.
      Поддерживает иконки из https://tabler.io/icons (более 5000 иконок)
      Дополнительные параметры можно передать в объекте icon:
      - color (ключ из allColors): Устанавливает цвет иконки из доступной цветовой палитры.
      - size (12 | 16 | 20 | 24 | 32): Размер иконки в пикселях.
      - type (IconType): Устанавливает тип иконки, позволяя выбирать различные стили.
      - icon (TablerIcons): Обязательный. Указывает иконку из доступного набора TablerIcons.
      - className (строка): Добавляет пользовательский CSS-класс для стилизации элемента иконки.
      - title (строка): Заголовок для доступности, отображается как подсказка при наведении.
      - hint (ReactNode): Дополнительная подсказка или всплывающая подсказка для контекста.
      - style (CSSProperties): Применяет встроенные стили непосредственно к иконке.
      - onClick (функция): Обработчик события нажатия на иконку, получает объект события.`
    ),
    new HelpNode(
      'input',
      'input(props)',
      `
      UI.input({ value: '...', type: 'text', placeholder: 'Enter text' });`,
      `
      const t = Items.get('... task id');

      const input = UI.input({
        type: 'text',
        placeholder: 'Enter your name',
        size: 'md',
        iconRight: 'IconCustomStarMark',
        label: 'Name',
        support: 'This is your display name',
        onChange: value => {
          console.log('Input changed:', value)
        },
        onIconRightClick: () => {
          console.log('Icon clicked')
        },
        iconRightError: true
      })
      t.ui.add(input);
      `,
      `
      Creates a customizable input field with various properties like value, type, placeholder, icons, labels, error state, and event handlers for focus, blur, key events, and icon actions.
      The component can be controlled by controlled is true. A controlled component requires passing the current value in the value parameter.`,
      `
      Создает настраиваемое поле ввода с различными свойствами, такими как значение, тип, плейсхолдер, иконки, метки, состояние ошибки, а также обработчики событий для фокуса, выхода, клавиш и действий с иконками.
      Компонент может быть управляемым, если передать controlled true. Управляемый компонент требует передачи актуального значения в параметре value при помощи метода rerender.`
    ),
    new HelpNode(
      'numberInput',
      'numberInput(props)',
      `
      UI.numberInput({ value: 1 });`,
      `
      const t = Items.get('... task id');

      const input = UI.numberInput({
        value: 1,
        min: 1,
        max: 10,
        onChange: value => {
          console.log('Input changed:', value)
        }
      })
      t.ui.add(input);
      `,
      `Creates a custom numeric input field with different properties such as value, min, max.`,
      `Создает настраиваемое числовое поле ввода с различными свойствами, такими как значение, минимальное, максимальное значение.`
    ),
    new HelpNode(
      'textarea',
      'textarea(props)',
      `
      UI.textarea({value: '1'})`,
      `
      const textarea = UI.textarea({
        autoFocus: true,
        allowNewLine: true,
        className: 'w-full',
        textAreaClassName: 'py-8 min-h-32',
        textSize: 'medium',
        onChange: api => {
          console.log('Textarea changed', api.text)
        },
        value: 'Stored data',
        allowSoftNewLine: true,
        label: 'Enter login',
        placeholder: 'Login'
      })`,
      `Creates a textarea with support multiple lines.`,
      `Создает многострочный инпут.`
    ),
    new HelpNode(
      'label',
      'label(id, text)',
      `
      UI.label('...');`,
      `
      var t = Items.get('... task id');
      var checkbox = UI.checkbox('case1-id');
      var label = UI.label('case1-id', 'checkbox-text');
      var value = false; // counter of the button clicks
      checkbox.onChange = function (newValue) {
        value = newValue
        t.ui.add(UI.text('Current value': newValue));
      };
      t.ui.add(checkbox);
      t.ui.add(label);`,
      `Creates a checkbox with label.`,
      `Создает чекбокс с надписью.`
    ),
    new HelpNode(
      'image',
      'image(src)',
      `
      UI.image('... image url');`,
      `
      var t = Items.get('... task id');
      var im = UI.image('https://goo.gl/KR53QM');
      t.ui.add(im);`,
      `Creates image element.`,
      `Создает элемент "изображение".`
    ),
    new HelpNode(
      'link',
      'link(text, url)',
      `
      UI.link('... text', '... url');`,
      `
      var t = Items.get('... task id');
      var a = UI.link('Google it!', 'https://google.com');
      t.ui.add(a);`,
      `Creates a hypertext link.`,
      `Создает ссылку.`
    ),
    new HelpNode(
      'linkButton',
      'linkButton(props)',
      `
      UI.linkButton({ text: '...', size: 'medium' });`,
      `
      var t = Items.get('... task id');
      var linkBtn = UI.linkButton({
        text: 'Go to page',
        size: 'big',
        icon: TablerIcons.ArrowRight,
      });
      linkBtn.style.color = 'blue';
      t.ui.add(linkBtn);

      // Add event handling for mouse down
      linkBtn.onMouseDown = function (e) {
        console.log('Link button pressed', e);
      }`,
      `Creates a customizable link button with text, size, icon, and an optional class name. You can also define behavior for mouse down events.`,
      `Создает настраиваемую ссылку-кнопку с текстом, размером, иконкой.`
    ),
    new HelpNode(
      'user',
      'user(user, size)',
      `
      UI.user(Users.get('...'));`,
      ``,
      `Creates a user photo icon with the specified user.`,
      `Создаёт иконку с аватаром пользователя.`
    ),
    new HelpNode(
      'userSelect',
      'userSelect(param)',
      `
      UI.userSelect({});`,
      `
      // all parameters are optional
      UI.userSelect({
        available: ['user1 id', 'user2 id'],
        chosen: ['user1 id'],
        onChoose: function (opts) {
          console.log('Chosen user ids' opts);
        },
        multiChoice: true,
        size: 32,
        title: 'Users'
      });`,
      `Creates user select element.`,
      `Создаёт элемент выбора пользователя из списка.`
    ),
    new HelpNode(
      'columnsSelect',
      'columnsSelect(param)',
      `
      UI.columnsSelect({});`,
      `
      // all parameters are optional
      UI.columnsSelect({
        onChange: function (props) {
          console.log('Selected columns', props);
        },
        columns: [
          {
            id: '000071aa-fe2d-436a-bb31-489d26f4e4b8',
            key: '000071aa-fe2d-436a-bb31-489d26f4e4b8',
            text: 'Column 1',
            selected: true
          },
          {
            id: '000071aa-fe2d-436a-bb31-489d26f4e4b1',
            key: '000071aa-fe2d-436a-bb31-489d26f4e4b1',
            text: 'Column 2',
            selected: false
          }
        ]
      });`,
      `Creates a column selection element.`,
      `Создаёт элемент для выбора колонок.`
    ),
    new HelpNode(
      'select',
      'select(param)',
      `
      UI.select({});`,
      `
      UI.select({
       options: [{
         key: '000071aa-fe2d-436a-bb31-489d26f4e4b8',
         text: 'Column 1',
       }],
       value: '',
       onChange: function (value) {
         console.log('Selected value', value);
       },
      })`,
      `Creates a selection element.`,
      `Создаёт селектор.`
    ),
    new HelpNode(
      'dateInput',
      'dateInput(param)',
      `
      UI.dateInput({onChange: (value: Date) => {}});`,
      `
      // all parameters are optional
      UI.dateInput({
        onChange: (value: Date) => {}
        initialValue: new Date()
        disablePastDate: true
        showTimeInput: true
      });`,
      `Creates date select element.`,
      `Создаёт элемент выбора даты со временем.`
    ),
    new HelpNode(
      'panel',
      'panel()',
      `
      UI.panel();`,
      `
      var t = Items.get('... task id');
      var p = UI.panel();
      t.ui.add(p);
      p.style = {
        background: '#acf',
        color: '#572'
      };
      p.add(UI.text('First element'));
      p.add(UI.text('Second element'));
      p.add(UI.button('Third element'));`,
      `Creates container (panel) for multiple elements.`,
      `Создает контейнер (panel) для разных элементов.`
    ),
    new HelpNode(
      'renderReact',
      'renderReact(renderer)',
      `
      `,
      ``,
      `Renders a React component inside the UI.`,
      `Отображает компонент React внутри UI.`
    ),
    new HelpNode(
      'openPopup',
      'openPopup(title, element, width, props)',
      `
      UI.openPopup('', UI.panel());`,
      `
      var t = UI.text('Test content');
      // open popup
      UI.openPopup('Test title', t);

      // open popup with custom width in pixels
      UI.openPopup('Test title', t, 300);

      // open popup with subtitle and other properties
      UI.openPopup('Test title', t, 300, { subTitle: 'Subtitle', autoHeight: true, paddings: 16 });
      `,
      `
      Opens a popup with the specified title and content. Optional properties can be provided
      to customize the appearance and behavior:
      - width (number): Width of the popup in pixels. Can be provided as a standalone third parameter or within "props".
      - subTitle (string): Subtitle displayed below the main title.
      - autoHeight (boolean): If true, the popup height adjusts automatically to content.
      - isNew (boolean): Indicates if the popup should be marked as new.
      - paddings (0 | 16 | 24): Padding around the content in pixels.
      `,
      `
      Открывает попап с заданными заголовком и содержимым. Дополнительные параметры можно передать
      для настройки внешнего вида и поведения:
      - width (число): Ширина попапа в пикселях. Может быть передана отдельным третьим параметром или в "props".
      - subTitle (строка): Подзаголовок, отображаемый под основным заголовком.
      - autoHeight (булево): Если true, высота попапа автоматически подстраивается под контент.
      - isNew (булево): Указывает, что попап должен быть отмечен как новый.
      - paddings (0 | 16 | 24): Отступы вокруг контента в пикселях.`
    ),
    new HelpNode(
      'setTaskInfoEl',
      'setTaskInfoEl(element)',
      `
      UI.setTaskInfoEl('', UI.panel());`,
      `
      var t = UI.text('Test content');
      // set element to task into section
      UI.setTaskInfoEl(t);
      `,
      `Set element to task into section with specified content.`,
      `Вставляет элемент в секцию taskInfo`
    ),
    new HelpNode(
      'setBoardSettingsEl',
      'setBoardSettingsEl(id, element)',
      `
      UI.setBoardSettingsEl('elementId', element);`,
      `
      const element = UI.text('Шаблоны форм контент');
      UI.setBoardSettingsEl('ext-forms', element);`,
      `Sets a specific UI element for the board settings.`,
      `Устанавливает определённый элемент UI для настроек доски.`
    ),
    new HelpNode(
      'closePopup',
      'closePopup()',
      `
      UI.closePopup();`,
      `
      var t = UI.text('Test content');
      UI.openPopup('Test title', t);

      // closing opened popup
       UI.closePopup();`,
      `Closes opened popup.`,
      `Закрывает открытый попап.`
    ),
    new HelpNode(
      'rawHtml',
      'rawHtml(html)',
      `
      UI.rawHtml('... html');`,
      `
      var t = Items.get('... task id');
      var html = \`
        Hi, <b>there</b>!
        <div id="my-el" onclick="alert('qwe')" style="color: red;">
          Click here!
        </div>
        <style>
          #my-el {
            background: #0ff;
          }
        </style>
      \`; // for IE use regular string with '' instead of \`\`
      t.ui.add(UI.rawHtml(html));`,
      `
      Creates element with the specified html.
      All the scripts and styles inside this html will work.
      So it is not safe to pass user-generated data as html to this component.`,
      `
      Создает элемент с указанным html-кодом.
      Все скрипты и стиле внутри этого html-кода будут работать.
      Таким образом, не безопасно передавать пользовательские данные
      как html в этот компонент.`
    ),
    new HelpNode(
      'safeHtml',
      'safeHtml(html)',
      `
      UI.safeHtml('... html');`,
      `
      var t = Items.get('... task id');
      var html = \`
        Hi, <b>there</b>!
        <br>
        <ul>
          <li>one</li>
          <li>two</li>
        </ul>
      \`; // for IE use regular string with '' instead of \`\`
      t.ui.add(UI.rawHtml(html));`,
      `
      Creates element with the specified html, html is cleaned from
      potentially unsafe tags, so it can not execute scripts.`,
      `
      Создает элемент с указанным html. html очищается от потенциально
      небезопасных тэгов, так что скрипты здесь не могут быть запущены.`
    ),
    new HelpNode(
      'selectText',
      'selectText(element)',
      `
      UI.selectText('... html element');`,
      `
      var text = UI.text();
      text.onRender = function () {
        UI.selectText(text.getElement());
      };`,
      `Selects all text inside html element.`,
      `Выделяет весь текст внутри html элемента.`
    ),
    new HelpNode(
      'getRightUrl',
      'getRightUrl(url)',
      `
      const url = UI.getRightUrl('... url to public file');`,
      ``,
      `Returns the correct URL for a public file.`,
      `Возвращает правильный URL для публичного файла.`
    ),
    new HelpNode(
      'setBlockVisibility',
      'setBlockVisibility(type, value)',
      `
      UI.setBlockVisibility('company-departments', false)
      UI.setBlockVisibility('company-users', false)`,
      ``,
      `Returns the correct URL for a public file.`,
      `Скрывает часть интерфейса в yougile`
    )
  ]
  const uiHelp = new HelpNode(
    'UI',
    'UI',
    `UI`,
    '',
    `
    Allows to customize components of user interface.
    Also allows to create new user interface elements and to add new
    interfaces inside existing ones.`,
    `
    Позволяет кастомизировать компоненты пользовательского интерфейса.
    Также позволяет создавать новые элементы интерфейса и добавлять новые
    элементы интерфейса внутрь имеющихся.`,
    uiFields
  )

  const uiHandlersFields = [
    new HelpNode(
      'onColumnMenuShow',
      'onColumnMenuShow(column)',
      `
      UIHandlers.onColumnMenuShow = function (column) {
        return [];
      };`,
      `
      UIHandlers.onColumnMenuShow = function (column) {
        return [
           {
             title: 'Menu name',
             onClick: function () {
               Notifier.success('Click');
             }
           }
        ];
      };`,
      `
      This function runs when user opens column menu. If you return
      array of menu items then they are added to the menu.`,
      `
      Эта функция вызывается когда пользователь открывает меню колонки.
      Если фукция возвращает массив элементов меню, то
      в меню добавляются пункты.`
    ),
    new HelpNode(
      'onBoardSettings',
      'onBoardSettings(board)',
      `
      UIHandlers.onBoardSettings = function (board) {
        return [];
      };`,
      `
      UIHandlers.onBoardSettings = function (board) {
        return [
           {
             id: 'ext-forms',
             title: 'Шаблоны форм',
             disabled: false,
             helpText: 'Помощь'
           }
        ];
      };
      `,
      `
      This function is triggered when the board settings are accessed. If you return
      an array of settings tabs, they are added to the board settings interface.`,
      `
      Эта функция вызывается, когда открываются настройки доски. Если функция возвращает
      массив вкладок настроек, они добавляются в интерфейс настроек доски.`
    ),
    new HelpNode(
      'onTriggerTaskDone',
      'onTriggerTaskDone(task)',
      `
      UIHandlers.onTriggerTaskDone = function (task) {};`,
      `
      UIHandlers.onBoardSettings = function (task) {};
      `,
      `This function is triggered when the task completion is changed.`,
      `Эта функция вызывается, когда статус выполнения задачи изменяется.`
    )
  ]
  const uiHandlersHelp = new HelpNode(
    'UIHandlers',
    'UIHandlers',
    `UIHandlers`,
    '',
    `Allows to intercept UI events and add custom elements to the system UI.`,
    `
    Позволяет перехватывать события отрисовки элементов системы и
    добавлять свои элементы в разные части системы.`,
    uiHandlersFields
  )

  const uiElementFields = [
    new HelpNode(
      'style',
      'style',
      `
      Items.get('...').ui.style;`,
      `
      var txt = UI.text('Ok');
      txt.style = {
        color: '#f00',
        fontSize: '18px'
      };`,
      `Object with css styles of the element.`,
      `Объект с css-свойствами элемента.`
    ),
    new HelpNode(
      'add',
      'add(element)',
      `
      Items.get('...').ui.add(UI.text(''));`,
      `
      var container = UI.panel();
      container.add(UI.text('Hello'));

      Items.get('...').ui.add(container);`,
      `Adds a new child element to the element.`,
      `Добавляет новый дочерний элемент.`
    ),
    new HelpNode(
      'appendTo',
      'appendTo(uiElement)',
      `
      UI.text('').appendTo(Items.get('...').ui);`,
      ``,
      `Adds the element as a child to some other element.`,
      `Добавляет элемент внутрь другого элемента.`
    ),
    new HelpNode(
      'getElement',
      'getElement()',
      `
      UI.text('').getElement()`,
      `
      var component = UI.text("Some text");
      component.onRender = function () {
        var el = component.getElement();
      };`,
      `
      Returns HTML element if this ui object was rendered, otherwise
      returns undefined.`,
      `
      Возвращает HTML элемент текущего UI объекта если он был отрисован,
      иначе возвращает undefined.`
    ),
    new HelpNode(
      'query',
      'query(selector)',
      `
      UI.text('').query('... css selector');`,
      `
      var component = UI.raw(\`
        <div>
          <video src="" class="my-video"></video>
        </div>
      \`);
      component.onRender = function () {
        var vidEl = component.query('.my-video')[0];
      };`,
      `
      Returns an array of HTML elements that match
      specified css-selector. If the element wasn't
      rendered then this method returns undefined.
      Use this method inside onRender function to get
      meaningful result.`,
      `
      Возвращает массив HTML-элементов, которые
      подходят под указанный css-селектор. Если элемент
      не был отрисован на странице, то этот метод вернёт undefined,
      поэтому его нужно использовать вместе с функцией onRender.`
    ),
    new HelpNode(
      'remove',
      'remove()',
      `
      UI.text('').remove();`,
      ``,
      `Removes element from its parent.`,
      `Убирает элемент из своего родительского элемента.`
    ),
    new HelpNode(
      'clear',
      'clear()',
      `
      UI.text('').clear();`,
      `
      var task = Items.get('...');
      var count = 0;
      setInterval(function () {
        count++;
        // remove previously added text
        task.ui.clean();
        task.ui.add(UI.text(count));
      }, 1000);`,
      `Clears all custom styles and removes custom elements from the element.`,
      `Очищает все дополнительные стили и убирает дочерние элементы.`
    ),
    new HelpNode(
      'showDefaults',
      'showDefaults',
      `
      UI.text('').showDefaults;`,
      `
      @code
      UI.text('').showDefaults;`,
      `Tells if default interfaces should be shown.`,
      `
      Если установить в false, то стандартные интерфейсы,
      связанные с этим элементом не будут отображаться.`
    ),
    new HelpNode(
      'parent',
      'parent',
      `
      Items.get('...').ui.parent;`,
      ``,
      `Returns a parent element`,
      `Возврашает родительский элемент.`
    ),
    new HelpNode(
      'children',
      'children',
      `
      Items.get('...').ui.children;`,
      ``,
      `Returns an array all child elements.`,
      `Возвращает массив всех дочерних элементов.`
    ),
    new HelpNode(
      'getChildById',
      'getChildById()',
      `
      `,
      ``,
      `Not implemented!
      `,
      `Not implemented!
      `
    ),
    new HelpNode(
      'refresh',
      'refresh()',
      `
      Items.get('...').ui.refresh();`,
      ``,
      `Redraws element.`,
      `Перерисовывает элемент.`
    ),
    new HelpNode(
      'watchMount',
      'watchMount(handler)',
      `
      Items.get('...').ui.watchMount(function (el) {
        el.classList.add('my-class');
      });`,
      ``,
      `Allows to subscribe to element initialization and changes.`,
      `Позволяет подписаться на инициализацию и изменения DOM элемента.`
    ),
    new HelpNode(
      'onClick',
      'onClick(e)',
      `
      (...).onClick = function (e) {
      };`,
      `
      var txt = UI.text('Click me!');
      txt.onClick = function () {
        alert('I was clicked!');
      };`,
      `Function that is called when element is clicked.`,
      `
      Функция, которая вызывается когда на элемент
      кликнули.`
    ),
    new HelpNode(
      'onRender',
      'onRender() => void)',
      `
      Items.get('...').onRender = ...`,
      ``,
      `This function is run when the element is rendered`,
      `Эта функция выполняется при отрисовке элемента`
    ),
    new HelpNode(
      'onKeyUp',
      'onKeyUp(e)',
      `
      `,
      ``,
      `Not implemented!
      `,
      `Not implemented!
      `
    ),
    new HelpNode(
      'onKeyDown',
      'onKeyDown(e)',
      `
      `,
      ``,
      `Not implemented!
      `,
      `Not implemented!
      `
    ),
    new HelpNode(
      'onUnmount',
      'onUnmount() => void)',
      `
      Items.get('...').onUnmount = ...`,
      ``,
      `This function is run when the element is removed`,
      `Эта функция выполняется при удалении элемента`
    ),
    new HelpNode(
      'isDrivenByReact',
      'isDrivenByReactboolean)',
      `
      `,
      ``,
      `If true, the element is driven by React and should not be modified by built-in methods.`,
      `Если true, то элемент управляется React и не должен изменяться встроенными методами.`
    )
  ]
  const uiElementHelp = new HelpNode(
    'UIElement',
    'ui variable',
    `UI.text('...');`,
    `
    var task = Items.get('...');
    var ui1 = task.ui; // task’s ui

    var ui2 = UI.components.chat; // ui for chat

    // creating new ui
    var ui3 = UI.text('Hello');
    // adding it to another ui
    ui1.add(ui3);`,
    `Represents element of user interface.`,
    `Переменная, представляющая элемент пользовательского интерфейса.`,
    uiElementFields
  )

  const eventsFields = [
    new HelpNode(
      'isShiftPressed',
      'isShiftPressed()',
      `
      Events.isShiftPressed();`,
      ``,
      ``,
      ``
    ),
    new HelpNode(
      'isCtrlPressed',
      'isCtrlPressed()',
      `
      Events.isCtrlPressed();`,
      ``,
      ``,
      ``
    ),
    new HelpNode(
      'isAltPressed',
      'isAltPressed()',
      `
      Events.isAltPressed();`,
      ``,
      ``,
      ``
    ),
    new HelpNode(
      'isMetaPressed',
      'isMetaPressed()',
      `
      Events.isMetaPressed();`,
      ``,
      ``,
      ``
    ),
    new HelpNode(
      'onKeyDown',
      'onKeyDown(e)',
      `
      Events.onKeyDown = function (event) {
        if (event.keyCode === '...') {
        }
      }`,
      ``,
      ``,
      ``
    ),
    new HelpNode(
      'onKeyUp',
      'onKeyUp(e)',
      `
      Events.onKeyUp = function (event) {
        if (event.keyCode === '...') {
        }
      }`,
      ``,
      ``,
      ``
    ),
    new HelpNode(
      'onClick',
      'onClick(e)',
      `
      Events.onClick = function (event) {
      }`,
      ``,
      ``,
      ``
    )
  ]
  const eventsHelp = new HelpNode(
    'Events',
    'Events',
    `Events`,
    '',
    `
    Gives access to the generic application events:
    user pressed a key,
    user went to another tab in browser,
    user clicked somewhere, …`,
    `
    Дает доступ к базовым событиям приложения:
    пользователь нажал на кнопку,
    пользователь перешел на другую вкладку браузера,
    пользователь куда-нибудь кликнул, …`,
    eventsFields
  )

  const usersFields = [
    new HelpNode(
      'listAll',
      'listAll()',
      `
      Users.listAll();`,
      `
      // saving all users to variable “all” for the later use
      var all = Users.listAll();
      // getting a task
      var t = Items.get('... task id here');
      // posting message “Hi!” on behalf of each user in the company
      all.forEach(function (u) {
        Chat.postMessage(t, u, 'Hi!');
      });`,
      `Returns all users added to the company.`,
      `Возвращает всех пользователей, добавленных в компанию.`
    ),
    new HelpNode(
      'get',
      'get(emailOrId)',
      `
      Users.get('... email or id here');`,
      `
      var user1 = Users.get('jack@example.com');
      var user2 = Users.get('... user id for another user');
      // ... doing something with “user1” and “user2”`,
      `Returns the user with the specified email or id.`,
      `Возвращает пользователя по указанному email или id.`
    ),
    new HelpNode(
      'isInProject',
      'isInProject(user, project)',
      `
      Users.isInProject(Users.get('... email or id'), Items.get('... id'));`,
      `
      // getting the project
      var prj = Items.get('... id');
      // checking if current user is added to the project
      if (Users.isInProject(Current.user, pr)) {
        Notifier.success('You are in the project!');
      }`,
      `Returns true if the user is added to the specified project.`,
      `Возвращает true, если пользователь добавлен к указанному проекту.`
    ),
    new HelpNode(
      'addToProject',
      'addToProject(user, project)',
      `
      Users.addToProject(Users.get('... email or id'), Items.get('... id'));`,
      `
      var pr = Items.get('... project id here');
      // adding current user to the project
      Users.addToProject(Current.user, pr);`,
      `Adds the user to the specified project.`,
      `Добавляет пользователя к указанному проекту.`
    ),
    new HelpNode(
      'removeFromProject',
      'removeFromProject(user, project)',
      `
      Users.removeFromProject(Users.get('...'), Items.get('... id'));`,
      `
      var pr = Items.get('... project id here');
      // removing current user to the project
      Users.removeFromProject(Current.user, pr);`,
      `Removes the user from the specified project.`,
      `Удаляет пользователя из указанного проекта.`
    ),
    new HelpNode(
      'listAllInProject',
      'listAllInProject(project)',
      `
      Users.listAllInProject(Items.get('... id'));`,
      `
      var p = Items.get('... project id here');
      var users = Users.listAllInProject(p);
      var names = users.map(function (u) {
        return u.name;
      });
      Notifier.success('Users: ' + names.join() + ' are in the project');`,
      `Returns all users added to the project.`,
      `Возвращает список пользователей, добавленных в проект.`
    ),
    new HelpNode(
      'getAssigned',
      'getAssigned(task, returnAll)',
      `
      Users.getAssigned(Items.get('... task id'));`,
      `
      var t = Items.get('... task id');
      var assigned = Users.getAssigned(t);
      Notifier.success('User ' + assigned.name + ' assigned to the task');

      // get all assigned users
      var allAssigned = Users.getAssigned(t, true); // allAssigned is an array`,
      `Returns the assigned user for the task.`,
      `Возвращает назначенного на задачу пользователя.`
    ),
    new HelpNode(
      'isUserAssigned',
      'isUserAssigned(user, task)',
      `
      Users.isUserAssigned(Users.get('...'), Items.get('... task id'));`,
      `
      var t = Items.get('... task id');
      if (Users.isUserAssigned(Current.user, t)) {
        Notifier.success('It is your job to complete task ' + t.name);
      } else {
        Notifier.success('Task ' + t.name + ' is someone else’s business');
      }`,
      `Returns true if the user is assigned to the specified task.`,
      `Возвращает true, если пользователь назначен на указанную задачу.`
    ),
    new HelpNode(
      'assignUser',
      'assignUser(user, task)',
      `
      Users.assignUser(Users.get('...'), Items.get('... task id'));`,
      `
      var t = Items.get('... task id');
      // assigning the task to the current user
      Users.assignUser(Current.user, t);

      // removing assignment
      Users.assignUser([], t);

      // adding multiple users
      Users.assignUser([user1, user2], t);`,
      `
      Assign a task to the specified user. To remove assignment you can pass
      undefined to the first argument.`,
      `
      Прикрепление указанного пользователя к задаче. Чтобы открепить
      пользователя, вы можете передать значние undefined к первому аргументу.`
    ),
    new HelpNode(
      'addToChat',
      'addToChat(user, task)',
      `
      Users.addToChat(Users.get('...'), Items.get('... task id'));`,
      `
      var t = Items.get('... task id');
      Users.addToChat(Current.user, t);`,
      `Adding the user to the specified chat (corresponding task is passed).`,
      `
      Добавляет пользователя к указанному чату (соответствующая задача
      передается).`
    ),
    new HelpNode(
      'removeFromChat',
      'removeFromChat(user, task)',
      `
      Users.removeFromChat(Users.get('...'), Items.get('... task id'));`,
      `
      var t = Items.get('... task id');
      Users.removeFromChat(Current.user, t);`,
      `
      Removing the user from the specified chat
      (corresponding task is passed).`,
      `
      Удаление юзера из нотификации по чату
      (соответствующая задача передается).`
    ),
    new HelpNode(
      'isInChat',
      'isInChat(user, task)',
      `
      Users.isInChat(Users.get('...'), Items.get('... task id'));`,
      `
      var t = Items.get('... task id');
      Users.isInChat(Current.user, t);`,
      `
      Returns true if the user is added to the specified chat
      (corresponding task is passed).`,
      `
      Возвращает true, если юзер добавлен в нотификацию по указанному
      чату (соответствующая задача передается).`
    ),
    new HelpNode(
      'listAllInChat',
      'listAllInChat(task)',
      `
      Users.listAllInChat(Items.get('... task id'));`,
      `
      var t = Items.get('... task id');
      Users.listAllInChat(t);`,
      `
      Gets all users who are added to the chat.
      Chat’s task is passed as an argument.`,
      `
      Получает всех пользователей, добавленных в чат.
      Задача передается как аргумент.`
    ),
    new HelpNode(
      'isHidden',
      'isHidden(user)',
      `
      Users.isHidden = function (user) {
        return false;
      };`,
      `
      Users.isHidden = function (u) {
        // do not show other users to the user
        return u.id === Current.user.id;
      };`,
      `Controls if user should be shown in lists of all users.`,
      `
      Позволяет указывать кто из пользователей показывается
      в списках пользователей (на странице проектов, в проекте,
      в списке уведомления по чату, в стикере Пользователь).`
    ),
    new HelpNode(
      'onList',
      'onList() => void)',
      `
      @todo implement`,
      ``,
      `Not implemented!
      `,
      `Not implemented!
      `
    ),
    new HelpNode(
      'onListInProject',
      'onListInProject() => void)',
      `
      @todo implement`,
      ``,
      `Not implemented!
      `,
      `Not implemented!
      `
    ),
    new HelpNode(
      'onListInChat',
      'onListInChat() => void)',
      `
      @todo implement`,
      ``,
      `Not implemented!
      `,
      `Not implemented!
      `
    ),
    new HelpNode(
      'onAddToProject',
      'onAddToProject() => void)',
      `
      @todo implement`,
      ``,
      `Not implemented!
      `,
      `Not implemented!
      `
    ),
    new HelpNode(
      'onRemoveFromProject',
      'onRemoveFromProject() => void)',
      `
      @todo implement`,
      ``,
      `Not implemented!
      `,
      `Not implemented!
      `
    ),
    new HelpNode(
      'onAddToChat',
      'onAddToChat() => void)',
      `
      @todo implement`,
      ``,
      `Not implemented!
      `,
      `Not implemented!
      `
    ),
    new HelpNode(
      'onRemoveFromChat',
      'onRemoveFromChat() => void)',
      `
      @todo implement`,
      ``,
      `Not implemented!
      `,
      `Not implemented!
      `
    ),
    new HelpNode(
      'onClick',
      'onClick() => void)',
      `
      @todo implement`,
      ``,
      `Not implemented!
      `,
      `Not implemented!
      `
    ),
    new HelpNode(
      'onDisplayName',
      'onDisplayName() => void)',
      `
      @todo implement`,
      ``,
      `Not implemented!
      `,
      `Not implemented!
      `
    )
  ]
  const usersHelp = new HelpNode(
    'Users',
    'Users',
    `Users`,
    '',
    `
    Manipulating users.
    Allows to get users’ info:
    names, emails, online statuses, photos, permissions, …
    Also allows to change who is in projects, who is assigned to
    tasks and who is added to chats.
    Allows to change the way user shown (name, photo, statuses).`,
    `
    Управление пользователями.
    Позволяет получит информацию о пользователях:
    Имена, e-mail, статусы, фотографии, разрешения и т.п.
    Также позволяет менять принадлежность к проектами, кто прикреплён
    к задаче и кто добавлен в нотификацию в чате.
    Позволяет изменять отображение пользователя (имя, фото, статусы).`,
    usersFields
  )

  const userObjFields = [
    new HelpNode(
      'name',
      'name',
      `
      Users.get('... user email or id').name;`,
      ``,
      `Returns user’s displayed name.`,
      `Возвращает отображаемое имя пользователя.`
    ),
    new HelpNode(
      'photo',
      'photo',
      `
      Users.get('... user email or id').photo;`,
      ``,
      `
      Returns url of user’s account photo, if photo is not set,
      then returns an empty string.`,
      `
      Возвращает url аватары пользователя. Если аватара не установлена,
      возвращает пустую строку.`
    ),
    new HelpNode(
      'email',
      'email',
      `
      Users.get('... user email or id').email;`,
      ``,
      `Returns user’s email.`,
      ``
    ),
    new HelpNode(
      'status',
      'status',
      `
      Users.get('... user email or id').status;`,
      ``,
      `Returns user’s status. Possible values are: 'online', 'offline', 'dnd'.`,
      `
      Возвращает статус пользователя. Возможные значения: 'online', 'offline',
      'dnd'.`
    ),
    new HelpNode(
      'dndUntil',
      'dndUntil',
      `
      Users.get('... user email or id').dndUntil;`,
      `
      var u = Users.get('peter@example.com');
      if (u.status === 'dnd') {
        var dndEnd = new Date(u.dndUntil);
        Notifier.warn('Peter is in Do-not-disturb mode until ' + dndEnd);
      }`,
      `
      If user status is 'dnd' then this method returns unix timestamp
      of dnd regime ending.`,
      `
      Если статус юзера - 'dnd', тогда этот метод возвращяет unix timestamp
      окончания статуса dnd.`
    ),
    new HelpNode(
      'lastActivity',
      'lastActivity',
      `
      Users.get('... user email or id').lastActivity;`,
      ``,
      `
      Returns the last time user was seen online (if the user is online,
      returns current timestamp).`,
      `
      Возвращает время, когда юзер был онлайн последний раз (если пользователь
      сейчас онлайн, возвращает текущий timestamp).`
    ),
    new HelpNode(
      'isAdmin',
      'isAdmin',
      `
      Users.get('... user email or id').isAdmin;`,
      ``,
      `
      Returns true if the user is admin. This value is readonly and can’t
      be changed with API.`,
      `
      Возвращает true, если юзер - админ. Это значение только для чтения и
      не может быть изменено через API.`
    ),
    new HelpNode(
      'getRole',
      'getRole(item)',
      `
      Users.get('... user email or id').getRole(Items.get('... item id'));`,
      `
      var user = Current.user;
      var board = Items.get('...');

      // role can be one of the following:
      // admin, worker, observer or roleId
      var role = user.getRole(board);
      console.log(role);`,
      `
      Return role in project, containing the specified item
      (project, board, column, task). Role in project can be 'admin',
      'worker', 'observer' or role id for curtom roles.`,
      `
      Возвращает роль в проекте, который содержит указанный объект типа item.
      Значение роли может быть 'admin' (управляющий), 'worker' (сотрудник),
      'observer' (наблюдатель) или строка с id роли для кастомных ролей.`
    ),
    new HelpNode(
      'getData',
      'getData()',
      `
      Users.get('... id').getData();`,
      `
      var u = Users.get('... user id');
      var d = t.getData();
      u.data = {
        clientId: '9023929875'
        contact: {
          phone: '+1234567',
          email: 'some@example.com'
        }
      };
      // this data is now saved on server and can be accessed
      // from scripts for all users.`,
      `Gets custom data attached to the user (see setData function).`,
      `
      Получает пользовательские данные, прикреплённые к пользователю
      (см. функцию setData).`
    ),
    new HelpNode(
      'setData',
      'setData(json)',
      `
      Users.get('... id').setData({...});`,
      `
      var u = Users.get('... id');
      var d = {
        clientId: '9023929875'
        contact: {
          phone: '+1234567',
          email: 'some@example.com'
        }
      };
      u.setData(d);
      // this data is now saved on server and can be accessed
      // from scripts for all users.

      // modification existent data example
      var data = u.getData();
      data.orderNum = 2341;
      u.setData(data);`,
      `
      Custom data can be attached to any user object
      (JSON). This data is automatically
      synchronized with server and all users and if available
      with getData function.`,
      `
      К любому пользователю в компании можно добавить пользовательские
      данные (JSON). Они будут автоматически синхронизированы
      с сервером и доступны через функцию getData.`
    )
  ]
  const userObjHelp = new HelpNode(
    'UserObj',
    'user variable',
    `Users.get('... email or id');`,
    `
    var john = Users.find('john@example.com');
    // “john” is a user variable now,
    // so we can access all properties available
    // (name, email, id, status, photo, …)
    if (john.status === 'online') {
      Notifier.warn('John is online!');
    } else {
      Notifier.warn('John is offline!');
    }
    // all these properties are readonly, but you can change
    // the way they are shown in to others by using methods
    // of the “Users” object`,
    `
    Represents a user, can be get by id or name by Users.get function
    (and also from Object navigator).`,
    `
    Переменная представляющая пользователя. Может быть получена по
    id или email-у из функции Users.get
    (также можно получить из Навигатора по объектам).`,
    userObjFields
  )

  const appFields = [
    new HelpNode(
      'clientType',
      'clientType()',
      `
      App.clientType();`,
      ``,
      `
      Returns the string with a type of the client,
      available types are: 'web', 'mobile', 'desktop'.`,
      `
      Возвращает строку с типом клиента.
      Доступные типы: 'web', 'mobile', 'desktop'.`
    ),
    new HelpNode(
      'time',
      'time()',
      `
      App.time();`,
      ``,
      `
      Returns unix timestamp of server time.
      Useful for teams with different
       timezones.`,
      `
      Возврашает unix timestamp серверного времени.
      (unix timestamp — количество миллисекунд, прошедшее с 00:00 1 янв 1970
      по Гринвичу)`
    ),
    new HelpNode(
      'lang',
      'lang()',
      `
      App.lang();`,
      ``,
      `Returns UI language: 'en', 'ru'.`,
      `Возвращает текущий язык пользовательского интерфейса: 'en', 'ru'.`
    ),
    new HelpNode(
      'formatDateTime',
      'formatDateTime(timestamp, options)',
      `
      App.formatDateTime(App.time());`,
      `
      var timestamp = App.time();
      var result = App.formatDateTime(timestamp, 'DD.MM.YYYY hh:mm');
      Notifier.success('Now is ' + result);`,
      `
      Converts server timestamp (see App.time) to
      a human-readable date-time string.`,
      `
      Конвертирует timestamp с сервера (см. App.time)
      в строку с датой и временем. Может применяться как с маской так и без`
    ),
    new HelpNode(
      'saveCsv',
      'saveCsv(filename, data, delim)',
      `
      App.saveCsv('...', []);`,
      `
      // creating rows
      var headerRow = ['Num', 'Name', 'Price', 'Amount'];
      var row1 = [1, 'Brick', 1.45, 1200];
      var row2 = [2, 'Stone', 0.57, 100];
      var row3 = [3, 'Wood', 0.99, 1450];
      var row4 = [4, 'Iron', 1.22, 800];

      // array of rows is a table
      var data = [headerRow, row1, row2, row3, row4];
      // download this table in .csv tsd format
      App.saveCsv('my-data.csv', data);`,
      `Save array to .csv file and download it.`,
      `Сохраняет массив в .csv-файл и скачивает его.`
    ),
    new HelpNode(
      'saveXlsx',
      'saveXlsx(filename, data)',
      `
      App.saveXlsx('...', []);`,
      `
      // creating rows
      var headerRow = ['Num', 'Name', 'Price', 'Amount'];
      var row1 = [1, 'Brick', 1.45, 1200];
      var row2 = [2, 'Stone', 0.57, 100];
      var row3 = [3, 'Wood', 0.99, 1450];
      var row4 = [4, 'Iron', 1.22, 800];

      // array of rows is a table
      var data = [headerRow, row1, row2, row3, row4];
      // download this table in .csv tsd format
      App.saveXlsx('my-data.xlsx', data);`,
      `Save array to .xlsx file and download it.`,
      `Сохраняет массив в .xlsx-файл и скачивает его.`
    ),
    new HelpNode(
      'chooseFile',
      'chooseFile(callback)',
      `
      App.chooseFile(function (file) {
      });`,
      `
      App.chooseFile(function (file) {
        Notifier.success('You’ve chosen file: ' + file.name);
      });`,
      `
      Asks user to choose a local file.
      After user chooses a file, callback function is called and this
      file is passed to it.`,
      `
      Предлагает пользователю выбрать файл с компьютера.
      После выбора файла вызывается callback, в который передаётся
      этот файл.`
    ),
    new HelpNode(
      'chooseAndUpload',
      'chooseAndUpload(callback)',
      `
      App.chooseAndUpload(function (url) {
      });`,
      `
      App.chooseAndUpload(function (url) {
        Notifier.success('File is uploaded to ' + url);
      });`,
      `
      Asks user to choose a local file, then uploads it to
      YouGile server and passes the url of that uploaded file
      to “callback”.`,
      `
      Предлагает пользователю выбрать файл, затем заливает
      этот файл на сервер и вызывает callback, куда передаёт
      url адрес залитого файла.`
    ),
    new HelpNode(
      'uploadFile',
      'uploadFile(file, callback)',
      `
      App.uploadFile(file, function (url) {
      });`,
      `
      // suppose we have a file already from Api.chooseFile
      // function or from <input type="file" ..../>
      Api.upload(file, function (url) {
        Notifier.success('File uploaded to url ' + url);
      });`,
      `
      Uploads the specified file to YouGile server and passes the url
      of the uploaded file to the callback.`,
      `
      Загружает файл на сервер YouGile и вызывает callback, куда передаёт
      адрес загруженного файла.`
    ),
    new HelpNode(
      'getPreviewUrl',
      'getPreviewUrl(url)',
      `
      App.getPreviewUrl('... url');`,
      `
      App.chooseAndUpload(function (url) {
        // here we have an url of the uploaded file
        // let’s get a preview
        var preview = App.getPreviewUrl(url);
        // now we can add it as an image url somewhere
        // let’s add to the top of the chat list
        UI.components.chat.add(UI.image(preview));
      });`,
      `
      If image file was uploaded to YouGile server
      (see App.chooseAndUpload) then small preview was
      automatically generated and information about it is stored
      in get-parameters of the uploaded image url. To get the url of
      this preview you can use this function.`,
      `
      Когда файл с изображением заливается на сервер YouGile
      (см. App.chooseAndUpload), автоматически создаётся небольшое превью,
      информация о котором сохраняется в get-параметрах url-адреса
      изображения. Эта функция (App.getPreviewUrl) позволяет получить
      url превью изображения.`
    ),
    new HelpNode(
      'httpGet',
      'httpGet(url, cb)',
      `
      App.httpGet('...', function (res) {
      });`,
      `
      App.httpGet('http://my-site.com/data?key=123', function (res) {
        var status = res.status; // status code
        if (status === 200) {
          var headers = res.headers; // response headers
          var body = res.body; // response body
        }
       });`,
      `Allows to make HTTP GET requests.`,
      `Позволяет делать HTTP GET запросы.`
    ),
    new HelpNode(
      'httpPost',
      'httpPost(url, params, headers, cb)',
      `
      App.httpPost('...', {});`,
      `
      var formData = {
        key1: 123,
        param2: 'test'
      };
      App.httpPost('http://my-site.com', formData).then(function (res) {
        var status = res.status; // status code
        if (status === 200) {
          var headers = res.headers; // response headers
          var body = res.body; // response body
        }
       });

      // with custom headers and form-encoded data
      var data = {
       some: 123
      };
      var requestHeaders = {
       'Content-Type': 'application/x-www-form-urlencoded',
       'api-key': 'abc'
      };
      App.httpPost('http://a.com', data, requestHeaders).then(function (res) {
        var status = res.status; // status code
        if (status === 200) {
          var headers = res.headers; // response headers
          var body = res.body; // response body
        }
       });`,
      `Allows to make HTTP POST requests.`,
      `Позволяет делать HTTP POST запросы.`
    ),
    new HelpNode(
      'copyToClipboard',
      'copyToClipboard(text)',
      `
      App.copyToClipboard('');`,
      `App.copyToClipboard('Some text');`,
      `Copies text to clipboard.`,
      `Копирует текст в буфер обмена.`
    ),
    new HelpNode(
      'allowUsersToInvite',
      'allowUsersToInvite',
      `
      App.allowUsersToInvite = false;`,
      `App.allowUsersToInvite = false;`,
      `
      If false, then users (not admins) can’t add another users to projects or
      invite other users to the company.`,
      `
      Если false, то пользователи (не админы) не могут добавлять кого-либо
      в проекты или приглашать новых пользователей в компанию.`
    ),
    new HelpNode(
      'onDisconnect',
      'onDisconnect() => void)',
      `
      `,
      ``,
      `Not implemented!
      `,
      `Not implemented!
      `
    ),
    new HelpNode(
      'onReconnect',
      'onReconnect() => void)',
      `
      `,
      ``,
      `Not implemented!
      `,
      `Not implemented!
      `
    ),
    new HelpNode(
      'onRemoteUpdate',
      'onRemoteUpdate() => void)',
      `
      `,
      ``,
      `Not implemented!
      `,
      `Not implemented!
      `
    ),
    new HelpNode(
      'onLocalUpdate',
      'onLocalUpdate() => void)',
      `
      `,
      ``,
      `Not implemented!
      `,
      `Not implemented!
      `
    )
  ]
  const appHelp = new HelpNode(
    'App',
    'App',
    `App`,
    '',
    `Collections of common application utilities.`,
    `Коллекция утилит приложения.`,
    appFields
  )

  return [
    notifierHelp,
    currentHelp,
    itemsHelp,
    itemHelp,
    stickersHelp,
    stickerObjHelp,
    chatHelp,
    messageObjHelp,
    textsHelp,
    uiHelp,
    uiHandlersHelp,
    uiElementHelp,
    eventsHelp,
    usersHelp,
    userObjHelp,
    appHelp
  ]
}
